console.log("LIGHTBOX JS LOADED");
// // airezxo page js
// (function() {
//   // 3D tilt 
//   var panel = document.getElementById('az-tilt-panel');
//   var img   = document.getElementById('az-tilt-img');
//   var shine = document.getElementById('az-shine');
//   if (panel && img) {
//     var rect = null, MAX = 14;
//     panel.addEventListener('mouseenter', function() {
//       rect = panel.getBoundingClientRect();
//       img.style.transition = 'transform 0.08s linear';
//     });
//     panel.addEventListener('mousemove', function(e) {
//       if (!rect) rect = panel.getBoundingClientRect();
//       var rx = Math.max(-MAX, Math.min(MAX, ((e.clientY - rect.top  - rect.height/2) / (rect.height/2)) * -MAX));
//       var ry = Math.max(-MAX, Math.min(MAX, ((e.clientX - rect.left - rect.width /2) / (rect.width /2)) *  MAX));
//       img.style.transform = 'rotateX(' + rx + 'deg) rotateY(' + ry + 'deg) scale(1.03)';
//       if (shine) {
//         var sx = 20 + ((e.clientX - rect.left) / rect.width)  * 60;
//         var sy = 20 + ((e.clientY - rect.top)  / rect.height) * 60;
//         shine.style.background = 'radial-gradient(circle at '+sx+'% '+sy+'%, rgba(255,255,255,.08) 0%, transparent 55%)';
//       }
//     });
//     panel.addEventListener('mouseleave', function() {
//       img.style.transition = 'transform 0.6s cubic-bezier(.22,.68,0,1.1)';
//       img.style.transform  = 'rotateX(0deg) rotateY(0deg) scale(1)';
//       if (shine) shine.style.background = 'radial-gradient(circle at 50% 50%, rgba(255,255,255,.04) 0%, transparent 60%)';
//       setTimeout(function() { img.style.transition = 'transform 0.08s linear'; }, 620);
//     });
//     panel.addEventListener('touchmove', function(e) {
//       if (!rect) rect = panel.getBoundingClientRect();
//       var t = e.touches[0];
//       var rx = Math.max(-MAX, Math.min(MAX, ((t.clientY - rect.top  - rect.height/2) / (rect.height/2)) * -MAX));
//       var ry = Math.max(-MAX, Math.min(MAX, ((t.clientX - rect.left - rect.width /2) / (rect.width /2)) *  MAX));
//       img.style.transform = 'rotateX(' + rx + 'deg) rotateY(' + ry + 'deg) scale(1.03)';
//     }, {passive:true});
//   }

//   // Reveal
//   var revEls = document.querySelectorAll('.r-up');
//   function showAll() { revEls.forEach(function(el) { el.classList.add('on'); }); }
//   if (window.IntersectionObserver) {
//     var io = new IntersectionObserver(function(entries) {
//       entries.forEach(function(e) {
//         if (e.isIntersecting) { e.target.classList.add('on'); io.unobserve(e.target); }
//       });
//     }, {threshold:0.05, rootMargin:'0px 0px -10px 0px'});
//     revEls.forEach(function(el) { io.observe(el); });
//     setTimeout(showAll, 1000);
//   } else { showAll(); }

//   // FAQ accordion
//   document.querySelectorAll('.faq-q').forEach(function(btn){
//     btn.addEventListener('click',function(){
//       var item=btn.closest('.faq-item');
//       var isOpen=item.classList.contains('open');
//       document.querySelectorAll('.faq-item.open').forEach(function(o){
//         o.classList.remove('open');
//         o.querySelector('.faq-q').setAttribute('aria-expanded','false');
//       });
//       if(!isOpen){item.classList.add('open');btn.setAttribute('aria-expanded','true');}
//     });
//   });

// })();

// // downloadable page js
//   (function() {
//   var search  = document.getElementById('dl-search');
//   var filters = document.querySelectorAll('.dl-fb');
//   var cards   = document.querySelectorAll('.dl-card');
//   var noRes   = document.getElementById('dl-no-results');
//   var dlCount = document.getElementById('dl-count');
//   var rcCount = document.getElementById('rc-count');
//   var wpCount = document.getElementById('wp-count');
//   var rcSec   = document.getElementById('rc-sec');
//   var wpSec   = document.getElementById('wp-sec');
//   var rcGrid  = document.getElementById('dl-rc');
//   var wpGrid  = document.getElementById('dl-wp');
//   var curFilter = 'all';

//   function update() {
//     var q = search.value.toLowerCase().trim();
//     var vis = 0, rcV = 0, wpV = 0;
//     cards.forEach(function(c) {
//       var name = (c.dataset.name || '').toLowerCase();
//       var type = c.dataset.type || '';
//       var show = (!q || name.indexOf(q) !== -1) && (curFilter === 'all' || type === curFilter);
//       c.classList.toggle('hidden', !show);
//       if (show) { vis++; if (type === 'rack') rcV++; else wpV++; }
//     });
//     dlCount.textContent = vis + ' file' + (vis !== 1 ? 's' : '');
//     if (rcCount) rcCount.textContent = rcV;
//     if (wpCount) wpCount.textContent = wpV;
//     var hideRc = rcV === 0 || curFilter === 'white';
//     var hideWp = wpV === 0 || curFilter === 'rack';
//     if (rcSec)  rcSec.style.display  = hideRc ? 'none' : '';
//     if (rcGrid) rcGrid.style.display = hideRc ? 'none' : '';
//     if (wpSec)  wpSec.style.display  = hideWp ? 'none' : '';
//     if (wpGrid) wpGrid.style.display = hideWp ? 'none' : '';
//     noRes.classList.toggle('show', vis === 0);
//   }

//   filters.forEach(function(btn) {
//     btn.addEventListener('click', function() {
//       filters.forEach(function(b) { b.classList.remove('active'); });
//       btn.classList.add('active');
//       curFilter = btn.dataset.filter;
//       update();
//     });
//   });

//   search.addEventListener('input', update);

//   var dlClear = document.getElementById('dl-clear');
//   if (dlClear && search) {
//     search.addEventListener('input', function() { dlClear.classList.toggle('show', search.value.length > 0); });
//     dlClear.addEventListener('click', function() { search.value=''; dlClear.classList.remove('show'); update(); search.focus(); });
//   }

// })();


//  Home page script
// Desktop dropdown toggle 
  (function () {

  function ready(fn) {
    if (document.readyState !== 'loading') {
      fn();
    } else {
      document.addEventListener('DOMContentLoaded', fn);
    }
  }

  ready(function () {

    /* ================= NAV DROPDOWN ================= */
    (function () {
      const buttons = document.querySelectorAll('.nav-item > button, .nav-account-wrap > button');
      if (!buttons.length) return;

      buttons.forEach(btn => {
        btn.addEventListener('click', e => {
          e.stopPropagation();

          const item = btn.closest('.nav-item, .nav-account-wrap');
          if (!item) return;

          const wasOpen = item.classList.contains('open');

          document.querySelectorAll('.nav-item.open, .nav-account-wrap.open').forEach(i => {
            i.classList.remove('open');
            const b = i.querySelector('button');
            if (b) b.setAttribute('aria-expanded', 'false');
          });

          if (!wasOpen) {
            item.classList.add('open');
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });

      document.addEventListener('click', () => {
        document.querySelectorAll('.nav-item.open, .nav-account-wrap.open').forEach(i => {
          i.classList.remove('open');
          const b = i.querySelector('button');
          if (b) b.setAttribute('aria-expanded', 'false');
        });
      });

    })();


    /* ================= HERO SLIDER ================= */
    (function () {
  const slides = document.querySelectorAll('.h-slide');
  const txtSlides = document.querySelectorAll('.hero-slide-txt');
  const dots = document.querySelectorAll('.hero-dot');
  const numEl = document.getElementById('hero-num');
  const progBar = document.getElementById('hero-prog');

  if (!slides.length || !dots.length) return;

  let cur = 0;
  let timer;
  const TOTAL = slides.length;
  const DURATION = 7000;

  function goTo(idx) {

    // OLD slide remove
    slides[cur]?.classList.remove('active');
    txtSlides[cur]?.classList.remove('active');
    dots[cur]?.classList.remove('active');

    // OLD slide video pause + reset
    const oldVideo = slides[cur]?.querySelector('video');

    if (oldVideo) {
      oldVideo.pause();
      oldVideo.currentTime = 0;
    }

    cur = idx;

    // NEW slide active
    slides[cur]?.classList.add('active');
    txtSlides[cur]?.classList.add('active');
    dots[cur]?.classList.add('active');

    // NEW slide video play from start
    const newVideo = slides[cur]?.querySelector('video');

    if (newVideo) {
      newVideo.currentTime = 0;

      const playPromise = newVideo.play();

      if (playPromise !== undefined) {
        playPromise.catch(err => {
          console.log('Video autoplay blocked:', err);
        });
      }
    }

    if (numEl) {
      numEl.textContent = String(cur + 1).padStart(2, '0');
    }

    if (progBar) {
      progBar.style.transition = 'none';
      progBar.style.width = '0%';

      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          progBar.style.transition = `width ${DURATION}ms linear`;
          progBar.style.width = '100%';
        });
      });
    }
  }

  function next() {
    goTo((cur + 1) % TOTAL);
  }

  function startTimer() {
    clearInterval(timer);
    timer = setInterval(next, DURATION);
  }

  dots.forEach(d => {
    d.addEventListener('click', () => {
      const idx = parseInt(d.dataset.idx);

      if (!isNaN(idx)) {
        goTo(idx);
        startTimer();
      }
    });
  });

  goTo(0);
  startTimer();

})();


    /* ================= VIDEO CAROUSEL ================= */
    (function () {
      const track = document.getElementById('viaTrack');
      if (!track) return;

      const dots = document.querySelectorAll('.via-dot');
      const prev = document.getElementById('viaPrev');
      const next = document.getElementById('viaNext');

      let cur = 0;
      const total = track.children.length;

      function goTo(idx) {
        cur = (idx + total) % total;
        track.style.transform = `translateX(-${cur * 100}%)`;

        dots.forEach((d, i) => {
          d.classList.toggle('active', i === cur);
        });
      }

      prev?.addEventListener('click', () => goTo(cur - 1));
      next?.addEventListener('click', () => goTo(cur + 1));

      dots.forEach(d => {
        d.addEventListener('click', () => {
          const idx = parseInt(d.dataset.idx);
          if (!isNaN(idx)) goTo(idx);
        });
      });

      // Swipe
      let startX = 0;
      track.addEventListener('touchstart', e => {
        startX = e.touches[0].clientX;
      }, { passive: true });

      track.addEventListener('touchend', e => {
        const dx = e.changedTouches[0].clientX - startX;
        if (Math.abs(dx) > 50) {
          goTo(dx < 0 ? cur + 1 : cur - 1);
        }
      });

    })();


    /* ================= TESTIMONIAL ================= */
    (function () {
      const slides = document.querySelectorAll('.testi-slide');
      const dots = document.querySelectorAll('.testi-dot');

      if (!slides.length) return;

      let idx = 0;
      let timer;

      function show(i) {
        slides.forEach((s, n) => s.classList.toggle('active', n === i));
        dots.forEach((d, n) => d.classList.toggle('active', n === i));
        idx = i;
      }

      function start() {
        clearInterval(timer);
        timer = setInterval(() => {
          show((idx + 1) % slides.length);
        }, 6000);
      }

      dots.forEach(d => {
        d.addEventListener('click', () => {
          const i = parseInt(d.dataset.i);
          if (!isNaN(i)) {
            show(i);
            start();
          }
        });
      });

      start();

    })();


    /* ================= HORIZONTAL SCROLL ================= */
    (function () {
      const scroller = document.getElementById('hscroll');
      const prev = document.getElementById('hscroll-prev');
      const next = document.getElementById('hscroll-next');

      if (!scroller || !prev || !next) return;

      const STEP = 320;

      prev.addEventListener('click', () => {
        scroller.scrollBy({ left: -STEP, behavior: 'smooth' });
      });

      next.addEventListener('click', () => {
        scroller.scrollBy({ left: STEP, behavior: 'smooth' });
      });

    })();


    /* ================= HEADER ================= */
    (function () {
      const nav = document.getElementById('nav');
      if (!nav) return;

      window.addEventListener('scroll', () => {
        nav.classList.toggle('scrolled', window.scrollY > 40);
      }, { passive: true });

    })();


    /* ================= MOBILE MENU + SEARCH ================= */
    (function () {
      const ico = document.querySelector('.nav-icon-btn.search-ico');
      const bar = document.getElementById('mob-search-bar');
      const closeBtn = document.getElementById('mob-search-close');
      const inp = document.getElementById('mob-search-input');

      function setDrawerOpen(open) {
        const drawer = document.getElementById('mob');
        const hbgBtn = document.getElementById('hbg');
        if (!drawer || !hbgBtn) return;

        drawer.classList.toggle('open', open);
        hbgBtn.classList.toggle('open', open);
        hbgBtn.setAttribute('aria-expanded', String(open));
        hbgBtn.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
        document.body.style.overflow = open ? 'hidden' : '';
      }

      function closeDrawer() {
        setDrawerOpen(false);
      }

      const hbg = document.getElementById('hbg');
      const mob = document.getElementById('mob');

      if (hbg && mob && !hbg.dataset.init) {
        hbg.dataset.init = "true";

        hbg.addEventListener('click', () => {
          setDrawerOpen(!mob.classList.contains('open'));
        });
      }

      document.addEventListener('click', e => {
        if (e.target.closest('#mob-close')) {
          e.preventDefault();
          e.stopPropagation();
          closeDrawer();
        }
      });

      mob?.querySelectorAll('a').forEach(link => {
        link.addEventListener('click', closeDrawer);
      });

      if (ico && bar && !ico.dataset.init) {
        ico.dataset.init = "true";

        ico.addEventListener('click', e => {
          e.preventDefault();
          bar.classList.toggle('open');

          if (bar.classList.contains('open')) {
            setTimeout(() => inp?.focus(), 100);
          }
        });
      }

      closeBtn?.addEventListener('click', () => {
        bar?.classList.remove('open');
      });

      document.addEventListener('keydown', e => {
        if (e.key === 'Escape') {
          bar?.classList.remove('open');
          if (document.getElementById('mob')?.classList.contains('open')) closeDrawer();
        }
      });

    })();


  });

})();


(function () {

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {

    /* ================= 3D TILT ================= */
    (function () {
      const panel = document.getElementById('az-tilt-panel');
      const img   = document.getElementById('az-tilt-img');
      const shine = document.getElementById('az-shine');

      if (!panel || !img || panel.dataset.init) return;
      panel.dataset.init = "true";

      let rect = null;
      const MAX = 14;

      function calc(x, y) {
        return {
          rx: Math.max(-MAX, Math.min(MAX, ((y - rect.top - rect.height / 2) / (rect.height / 2)) * -MAX)),
          ry: Math.max(-MAX, Math.min(MAX, ((x - rect.left - rect.width / 2) / (rect.width / 2)) * MAX))
        };
      }

      panel.addEventListener('mouseenter', () => {
        rect = panel.getBoundingClientRect();
        img.style.transition = 'transform 0.08s linear';
      });

      panel.addEventListener('mousemove', (e) => {
        if (!rect) rect = panel.getBoundingClientRect();
        const { rx, ry } = calc(e.clientX, e.clientY);

        img.style.transform = `rotateX(${rx}deg) rotateY(${ry}deg) scale(1.03)`;

        if (shine) {
          const sx = 20 + ((e.clientX - rect.left) / rect.width) * 60;
          const sy = 20 + ((e.clientY - rect.top) / rect.height) * 60;
          shine.style.background = `radial-gradient(circle at ${sx}% ${sy}%, rgba(255,255,255,.08) 0%, transparent 55%)`;
        }
      });

      panel.addEventListener('mouseleave', () => {
        img.style.transition = 'transform 0.6s cubic-bezier(.22,.68,0,1.1)';
        img.style.transform  = 'rotateX(0deg) rotateY(0deg) scale(1)';

        if (shine) {
          shine.style.background = 'radial-gradient(circle at 50% 50%, rgba(255,255,255,.04) 0%, transparent 60%)';
        }
      });

      panel.addEventListener('touchmove', (e) => {
        if (!rect) rect = panel.getBoundingClientRect();
        const t = e.touches[0];
        const { rx, ry } = calc(t.clientX, t.clientY);
        img.style.transform = `rotateX(${rx}deg) rotateY(${ry}deg) scale(1.03)`;
      }, { passive: true });

    })();


    /* ================= REVEAL ANIMATION ================= */
    (function () {
      const els = document.querySelectorAll('.r-up');
      if (!els.length) return;

      function showAll() {
        els.forEach(el => el.classList.add('on'));
      }

      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach(e => {
            if (e.isIntersecting) {
              e.target.classList.add('on');
              io.unobserve(e.target);
            }
          });
        }, { threshold: 0.05, rootMargin: '0px 0px -10px 0px' });

        els.forEach(el => io.observe(el));
        setTimeout(showAll, 1200);

      } else {
        showAll();
      }

    })();


    /* ================= FAQ ================= */
    (function () {
      const buttons = document.querySelectorAll('.faq-q');
      if (!buttons.length) return;

      buttons.forEach(btn => {
        btn.addEventListener('click', () => {
          const item = btn.closest('.faq-item');
          if (!item) return;

          const isOpen = item.classList.contains('open');

          document.querySelectorAll('.faq-item.open').forEach(o => {
            o.classList.remove('open');
            const b = o.querySelector('.faq-q');
            if (b) b.setAttribute('aria-expanded', 'false');
          });

          if (!isOpen) {
            item.classList.add('open');
            btn.setAttribute('aria-expanded', 'true');
          }
        });
      });

    })();


    /* ================= DOWNLOAD FILTER ================= */
    (function () {
      const search  = document.getElementById('dl-search');
      const filters = document.querySelectorAll('.dl-fb');
      const cards   = document.querySelectorAll('.dl-card');
      const noRes   = document.getElementById('dl-no-results');

      if (!cards.length || !search) return;

      const dlCount = document.getElementById('dl-count');
      const rcCount = document.getElementById('rc-count');
      const wpCount = document.getElementById('wp-count');

      const rcSec  = document.getElementById('rc-sec');
      const wpSec  = document.getElementById('wp-sec');
      const rcGrid = document.getElementById('dl-rc');
      const wpGrid = document.getElementById('dl-wp');

      let curFilter = 'all';

      function update() {
        const q = search.value.toLowerCase().trim();
        let vis = 0, rcV = 0, wpV = 0;

        cards.forEach(c => {
          const name = (c.dataset.name || '').toLowerCase();
          const type = c.dataset.type || '';

          const show =
            (!q || name.includes(q)) &&
            (curFilter === 'all' || type === curFilter);

          c.classList.toggle('hidden', !show);

          if (show) {
            vis++;
            if (type === 'rack') rcV++;
            else wpV++;
          }
        });

        if (dlCount) dlCount.textContent = `${vis} file${vis !== 1 ? 's' : ''}`;
        if (rcCount) rcCount.textContent = rcV;
        if (wpCount) wpCount.textContent = wpV;

        const hideRc = rcV === 0 || curFilter === 'white';
        const hideWp = wpV === 0 || curFilter === 'rack';

        if (rcSec)  rcSec.style.display  = hideRc ? 'none' : '';
        if (rcGrid) rcGrid.style.display = hideRc ? 'none' : '';

        if (wpSec)  wpSec.style.display  = hideWp ? 'none' : '';
        if (wpGrid) wpGrid.style.display = hideWp ? 'none' : '';

        noRes?.classList.toggle('show', vis === 0);
      }

      filters.forEach(btn => {
        btn.addEventListener('click', () => {
          filters.forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          curFilter = btn.dataset.filter || 'all';
          update();
        });
      });

      search.addEventListener('input', update);

      const clear = document.getElementById('dl-clear');
      if (clear) {
        search.addEventListener('input', () => {
          clear.classList.toggle('show', search.value.length > 0);
        });

        clear.addEventListener('click', () => {
          search.value = '';
          clear.classList.remove('show');
          update();
          search.focus();
        });
      }

      update();

    })();


  });

})();


// our equipmnent page js 
(function () {

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {

    /* ================= CARD CLICK ================= */
    (function () {
      const cards = document.querySelectorAll('.ep-card[data-href]');
      if (!cards.length) return;

      cards.forEach(card => {
        if (card.dataset.init) return;
        card.dataset.init = "true";

        card.addEventListener('click', (e) => {
          // prevent conflict with links/buttons inside
          if (e.target.closest('a, button')) return;

          const url = card.getAttribute('data-href');
          if (url) window.location.href = url;
        });
      });
    })();


    /* ================= RESET INLINE STYLES ================= */
    (function () {
      const cards = document.querySelectorAll('.ep-card');
      if (!cards.length) return;

      cards.forEach(c => {
        c.style.removeProperty('opacity');
        c.style.removeProperty('transform');
        c.style.removeProperty('transition');
      });
    })();


    /* ================= FILTER ================= */
    (function () {
      const buttons = document.querySelectorAll('.ep-fbtn');
      const sections = document.querySelectorAll('.ep-sec[data-section]');
      const filterWrap = document.getElementById('ep-filter');

      if (!buttons.length || !sections.length) return;

      buttons.forEach(btn => {
        if (btn.dataset.init) return;
        btn.dataset.init = "true";

        btn.addEventListener('click', () => {
          // active state
          buttons.forEach(b => b.classList.remove('active'));
          btn.classList.add('active');

          const filter = btn.getAttribute('data-filter');

          sections.forEach(sec => {
            const secName = sec.getAttribute('data-section');
            sec.style.display =
              (filter === 'All' || secName === filter) ? '' : 'none';
          });

          // safe scroll
          filterWrap?.scrollIntoView({
            behavior: 'smooth',
            block: 'nearest'
          });
        });
      });

    })();

  });

})();

// hp100 page js
(function () {

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {

    /* ================= 3D TILT ================= */
    (function () {
      const panel = document.getElementById('hp-tilt-panel');
      const img   = document.getElementById('hp-tilt-img');
      const shine = document.getElementById('hp-shine');

      if (!panel || !img || panel.dataset.init) return;
      panel.dataset.init = "true";

      let rect = null;
      const MAX = 14;

      function calc(x, y) {
        return {
          rx: Math.max(-MAX, Math.min(MAX, ((y - rect.top - rect.height / 2) / (rect.height / 2)) * -MAX)),
          ry: Math.max(-MAX, Math.min(MAX, ((x - rect.left - rect.width / 2) / (rect.width / 2)) * MAX))
        };
      }

      panel.addEventListener('mouseenter', () => {
        rect = panel.getBoundingClientRect();
        img.style.transition = 'transform 0.08s linear';
      });

      panel.addEventListener('mousemove', (e) => {
        if (!rect) rect = panel.getBoundingClientRect();
        const { rx, ry } = calc(e.clientX, e.clientY);

        img.style.transform = `rotateX(${rx}deg) rotateY(${ry}deg) scale(1.03)`;

        if (shine) {
          const sx = 20 + ((e.clientX - rect.left) / rect.width) * 60;
          const sy = 20 + ((e.clientY - rect.top) / rect.height) * 60;
          shine.style.background =
            `radial-gradient(circle at ${sx}% ${sy}%, rgba(255,255,255,.07) 0%, transparent 55%)`;
        }
      });

      panel.addEventListener('mouseleave', () => {
        img.style.transition = 'transform 0.6s cubic-bezier(.22,.68,0,1.1)';
        img.style.transform  = 'rotateX(0deg) rotateY(0deg) scale(1)';

        if (shine) {
          shine.style.background =
            'radial-gradient(circle at 50% 50%, rgba(255,255,255,.04) 0%, transparent 60%)';
        }
      });

      panel.addEventListener('touchmove', (e) => {
        if (!rect) rect = panel.getBoundingClientRect();
        const t = e.touches[0];
        const { rx, ry } = calc(t.clientX, t.clientY);
        img.style.transform = `rotateX(${rx}deg) rotateY(${ry}deg) scale(1.03)`;
      }, { passive: true });

    })();


    /* ================= REVEAL ================= */
    (function () {
      const els = document.querySelectorAll('.r-up');
      if (!els.length) return;

      function showAll() {
        els.forEach(el => el.classList.add('on'));
      }

      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach(e => {
            if (e.isIntersecting) {
              e.target.classList.add('on');
              io.unobserve(e.target);
            }
          });
        }, { threshold: 0.05, rootMargin: '0px 0px -10px 0px' });

        els.forEach(el => io.observe(el));
        setTimeout(showAll, 1200);
      } else {
        showAll();
      }

    })();


    /* ================= GALLERY ================= */
    (function () {
      const galImg   = document.getElementById('hp-gi');
      const galThs   = document.querySelectorAll('.hp-gth');
      const galCount = document.getElementById('hp-gc');
      const lb       = document.getElementById('hp-lb');
      const lbImg    = document.getElementById('hp-lb-img');
      const lbX      = document.getElementById('hp-lb-x');
      const galMain  = document.getElementById('hp-gm');

      if (!galThs.length || !galImg) return;

      const gsrcs = [
        "https://cdn.shopify.com/s/files/1/0224/7891/3616/files/imgpsh_fullsize_anim_4.png?v=1693305130",
        "https://cdn.shopify.com/s/files/1/0224/7891/3616/files/imgpsh_fullsize_anim_4.jpg?v=1693416361",
        "https://cdn.shopify.com/s/files/1/0224/7891/3616/files/Screenshot_2023-08-30_at_11.28.27_PM.png?v=1693418343"
      ];

      let current = 0;

      function setGal(i) {
        if (!gsrcs[i]) return;

        current = i;

        galThs.forEach(b => b.classList.remove('on'));
        galThs[i]?.classList.add('on');

        galImg.style.opacity = '0';

        setTimeout(() => {
          galImg.src = gsrcs[i];
          galImg.style.opacity = '1';
        }, 200);

        if (galCount) {
          galCount.textContent = `${i + 1} / ${gsrcs.length}`;
        }
      }

      galThs.forEach((t, i) => {
        t.addEventListener('click', () => setGal(i));
      });

      if (galMain && lb && lbImg) {
        galMain.addEventListener('click', () => {
          lbImg.src = galImg.src;
          lb.classList.add('on');
          document.body.style.overflow = 'hidden';
        });
      }

      function closeLb() {
        if (!lb) return;
        lb.classList.remove('on');
        document.body.style.overflow = '';
      }

      lbX?.addEventListener('click', closeLb);

      lb?.addEventListener('click', (e) => {
        if (e.target === lb) closeLb();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeLb();
      });

      // init
      setGal(0);

    })();


  });

})();

// Hydrogen water page js
(function () {

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {

    /* ================= 3D TILT ================= */
    (function () {
      const panel = document.getElementById('hw-tilt-panel');
      const img   = document.getElementById('hw-tilt-img');
      const shine = document.getElementById('hw-shine');

      if (!panel || !img || panel.dataset.init) return;
      panel.dataset.init = "true";

      let rect = null;
      const MAX = 14;

      function calc(x, y) {
        return {
          rx: Math.max(-MAX, Math.min(MAX, ((y - rect.top - rect.height / 2) / (rect.height / 2)) * -MAX)),
          ry: Math.max(-MAX, Math.min(MAX, ((x - rect.left - rect.width / 2) / (rect.width / 2)) * MAX))
        };
      }

      panel.addEventListener('mouseenter', () => {
        rect = panel.getBoundingClientRect();
        img.style.transition = 'transform 0.08s linear';
      });

      panel.addEventListener('mousemove', (e) => {
        if (!rect) rect = panel.getBoundingClientRect();
        const { rx, ry } = calc(e.clientX, e.clientY);

        img.style.transform = `rotateX(${rx}deg) rotateY(${ry}deg) scale(1.03)`;

        if (shine) {
          const sx = 20 + ((e.clientX - rect.left) / rect.width) * 60;
          const sy = 20 + ((e.clientY - rect.top) / rect.height) * 60;
          shine.style.background =
            `radial-gradient(circle at ${sx}% ${sy}%, rgba(255,255,255,.08) 0%, transparent 55%)`;
        }
      });

      panel.addEventListener('mouseleave', () => {
        img.style.transition = 'transform 0.6s cubic-bezier(.22,.68,0,1.1)';
        img.style.transform  = 'rotateX(0deg) rotateY(0deg) scale(1)';
      });

      panel.addEventListener('touchmove', (e) => {
        if (!rect) rect = panel.getBoundingClientRect();
        const t = e.touches[0];
        const { rx, ry } = calc(t.clientX, t.clientY);
        img.style.transform = `rotateX(${rx}deg) rotateY(${ry}deg) scale(1.03)`;
      }, { passive: true });

    })();


    /* ================= REVEAL ================= */
    (function () {
      const els = document.querySelectorAll('.r-up');
      if (!els.length) return;

      function showAll() {
        els.forEach(el => el.classList.add('on'));
      }

      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach(e => {
            if (e.isIntersecting) {
              e.target.classList.add('on');
              io.unobserve(e.target);
            }
          });
        }, { threshold: 0.05, rootMargin: '0px 0px -10px 0px' });

        els.forEach(el => io.observe(el));
        setTimeout(showAll, 1200);
      } else {
        showAll();
      }

    })();


    /* ================= GALLERY ================= */
    (function () {
      const gImg  = document.getElementById('hw-gi');
      const gThs  = document.querySelectorAll('.hw-gth');
      const gCnt  = document.getElementById('hw-gc');
      const lb    = document.getElementById('tc-lb');
      const lbImg = document.getElementById('tc-lb-img');
      const lbX   = document.getElementById('tc-lb-x');
      const gMain = document.getElementById('hw-gm');

      if (!gImg || !gThs.length) return;

      const srcs = [
        "https://cdn.shopify.com/s/files/1/0224/7891/3616/files/imgpsh_fullsize_anim.png?v=1693288759",
        "https://cdn.shopify.com/s/files/1/0224/7891/3616/files/imgpsh_fullsize_anim_3.png?v=1693303584",
        "https://cdn.shopify.com/s/files/1/0224/7891/3616/files/Why_use_hydrogen_water.png?v=1711561892",
        "https://cdn.shopify.com/s/files/1/0224/7891/3616/files/imgpsh_fullsize_anim_4.png?v=1693305130",
        "https://cdn.shopify.com/s/files/1/0224/7891/3616/files/imgpsh_fullsize_anim_4.jpg?v=1693416361"
      ];

      let current = 0;

      function setG(i) {
        if (!srcs[i]) return;

        current = i;

        gThs.forEach(b => b.classList.remove('on'));
        gThs[i]?.classList.add('on');

        gImg.style.opacity = '0';

        setTimeout(() => {
          gImg.src = srcs[i];
          gImg.style.opacity = '1';
        }, 200);

        if (gCnt) {
          gCnt.textContent = `${i + 1} / ${srcs.length}`;
        }
      }

      gThs.forEach((t, i) => {
        t.addEventListener('click', () => setG(i));
      });

      if (gMain && lb && lbImg) {
        gMain.addEventListener('click', () => {
          lbImg.src = gImg.src;
          lb.classList.add('on');
          document.body.style.overflow = 'hidden';
        });
      }

      function closeLb() {
        if (!lb) return;
        lb.classList.remove('on');
        document.body.style.overflow = '';
      }

      lbX?.addEventListener('click', closeLb);

      lb?.addEventListener('click', (e) => {
        if (e.target === lb) closeLb();
      });

      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') closeLb();
      });

      setG(0);

    })();

  });

})();

// Quantum cellular scan training page js
(function () {

  function ready(fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  }

  ready(function () {

    /* ================= REVEAL ================= */
    (function () {
      const els = document.querySelectorAll('.r-up');
      if (!els.length) return;

      function showAll() {
        els.forEach(el => el.classList.add('on'));
      }

      if ('IntersectionObserver' in window) {
        const io = new IntersectionObserver((entries) => {
          entries.forEach(e => {
            if (e.isIntersecting) {
              e.target.classList.add('on');
              io.unobserve(e.target);
            }
          });
        }, { threshold: 0.06, rootMargin: '0px 0px -8px 0px' });

        els.forEach(el => io.observe(el));
        setTimeout(showAll, 1200);
      } else {
        showAll();
      }
    })();


    /* ================= RING ================= */
    (function () {
      const ring = document.getElementById('qcs-ring');
      if (!ring) return;

      setTimeout(() => {
        ring.style.strokeDashoffset = '0';
      }, 500);
    })();


    // /* ================= LIGHTBOX (FIXED) ================= */

    (function () {
      const cards = document.querySelectorAll('.qcs-card');
      const lb = document.getElementById('qcs-lb');
      const lbVid = document.getElementById('qcs-lb-video');
      const lbCap = document.getElementById('qcs-lb-cap');
      const lbSub = document.getElementById('qcs-lb-sub');
      const lbCtr = document.getElementById('qcs-lb-counter');
      const lbX = document.getElementById('qcs-lb-x');
      const lbPrev = document.getElementById('qcs-lb-prev');
      const lbNext = document.getElementById('qcs-lb-next');

      if (!cards.length || !lb || !lbVid) return;

      // ✅ Dummy YouTube embed URLs
      const videos = [
        "https://player.vimeo.com/video/813649258?h=1d7b4fc642&amp;dnt=1&amp;app_id=122963",
        "https://player.vimeo.com/video/813648438?h=8e7bd1b1ed&amp;dnt=1&amp;app_id=122963",
        "https://player.vimeo.com/video/813649213?h=8e596b2f44&amp;dnt=1&amp;app_id=122963",
        "https://player.vimeo.com/video/813649064?h=7f99c2bd50&amp;dnt=1&amp;app_id=122963",
        "https://player.vimeo.com/video/813648947?h=efa58a69c0&amp;dnt=1&amp;app_id=122963",
        "https://player.vimeo.com/video/813648082?h=3fe11c152e&amp;dnt=1&amp;app_id=122963",
        "https://player.vimeo.com/video/813648047?h=9cec456280&amp;dnt=1&amp;app_id=122963",
        "https://player.vimeo.com/video/813648001?h=eb86f7ce8e&amp;dnt=1&amp;app_id=122963",
        "https://player.vimeo.com/video/813647924?h=792daae3f4&amp;dnt=1&amp;app_id=122963",
        "https://player.vimeo.com/video/813647694?h=a3bb9ef11b&amp;dnt=1&amp;app_id=122963",
        "https://player.vimeo.com/video/813647611?h=0045874c7c&amp;dnt=1&amp;app_id=122963"
      ];

      const titles = [
        "AnyDesk Installation",
        "QCS Test Flow & Smart Form",
        "Training Video Zoom",
        "Worksheet Report Detail Review",
        "Worksheet Overview",
        "Test Flow & Smart Form — Advanced",
        "Retest & Finding a Previous Test",
        "Client Connection to Server",
        "Back Office Analysis",
        "Building a Custom Complete",
        "Advanced Therapy Using Frex"
      ];

      const descs = [
        "Set up remote desktop access with AnyDesk.",
        "Complete QCS test flow and Smart Form usage.",
        "Run training sessions via Zoom.",
        "Understand Worksheet Report deeply.",
        "Overview of worksheet layout.",
        "Advanced QCS techniques.",
        "Find and retest previous clients.",
        "Connect client machine securely.",
        "Back office management tools.",
        "Build custom tests.",
        "Advanced therapy protocols."
      ];

      let curIdx = 0;

      function clean(str) {
        return (str || '')
          .replace(/&amp;/g, '&')
          .replace(/<[^>]+>/g, '');
      }

      function openLb(idx) {
        if (!videos[idx]) return;

        curIdx = idx;

        // autoplay added
        lbVid.src = videos[idx] + "?autoplay=1";

        if (lbCap) lbCap.textContent = `Lesson ${idx + 1}: ${clean(titles[idx])}`;
        if (lbSub) lbSub.textContent = clean(descs[idx]);
        if (lbCtr) lbCtr.textContent = `${idx + 1} / ${videos.length}`;

        lb.classList.add('on');
        document.body.style.overflow = 'hidden';
      }

      function closeLb() {
        lb.classList.remove('on');
        document.body.style.overflow = '';

        // stop video
        lbVid.src = "";
      }

      cards.forEach((card, i) => {
        if (card.dataset.init) return;
        card.dataset.init = "true";

        card.setAttribute('tabindex', '0');
        card.setAttribute('role', 'button');

        card.addEventListener('click', () => openLb(i));

        card.addEventListener('keydown', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            openLb(i);
          }
        });
      });

      lbX?.addEventListener('click', closeLb);

      lb?.addEventListener('click', (e) => {
        if (e.target === lb) closeLb();
      });

      lbPrev?.addEventListener('click', () => {
        openLb((curIdx - 1 + videos.length) % videos.length);
      });

      lbNext?.addEventListener('click', () => {
        openLb((curIdx + 1) % videos.length);
      });

      document.addEventListener('keydown', (e) => {
        if (!lb.classList.contains('on')) return;

        if (e.key === 'Escape') closeLb();
        if (e.key === 'ArrowLeft') openLb((curIdx - 1 + videos.length) % videos.length);
        if (e.key === 'ArrowRight') openLb((curIdx + 1) % videos.length);
      });

    })();


    /* ================= CATEGORY FILTER ================= */
    (function () {
      const cats = document.querySelectorAll('.qcs-cat');
      const cards = document.querySelectorAll('.qcs-card');

      if (!cats.length || !cards.length) return;

      cats.forEach(btn => {
        btn.addEventListener('click', () => {
          cats.forEach(b => b.classList.remove('active'));
          btn.classList.add('active');

          const f = btn.dataset.cat;

          cards.forEach(c => {
            const tag = c.querySelector('.qcs-tag');
            const txt = tag?.textContent.trim();

            c.classList.toggle('hidden', f !== 'all' && txt !== f);
          });
        });
      });

    })();


  });

})();

// Vibex passport page js
(function() {
  /* ================== 3D Tilt on Hero Image ================== */
  (function initTilt() {
    const panel = document.getElementById('vp-tilt-panel');
    const img = document.getElementById('vp-tilt-img');
    const shine = document.getElementById('vp-shine');
    if (!panel || !img) return;

    let rect = null;
    const MAX = 14;

    panel.addEventListener('mouseenter', () => {
      rect = panel.getBoundingClientRect();
      img.style.transition = 'transform 0.08s linear, filter 0.08s linear';
    });

    panel.addEventListener('mousemove', (e) => {
      if (!rect) rect = panel.getBoundingClientRect();
      const cx = rect.left + rect.width/2;
      const cy = rect.top + rect.height/2;
      const rx = Math.max(-MAX, Math.min(MAX, ((e.clientY - cy)/(rect.height/2))*-MAX));
      const ry = Math.max(-MAX, Math.min(MAX, ((e.clientX - cx)/(rect.width/2))*MAX));
      img.style.transform = `rotateX(${rx}deg) rotateY(${ry}deg) scale(1.03)`;

      if (shine) {
        const sx = 20 + ((e.clientX - rect.left)/rect.width)*60;
        const sy = 20 + ((e.clientY - rect.top)/rect.height)*60;
        shine.style.background = `radial-gradient(circle at ${sx}% ${sy}%, rgba(255,255,255,.08) 0%, transparent 55%)`;
      }
    });

    panel.addEventListener('mouseleave', () => {
      img.style.transition = 'transform 0.6s cubic-bezier(.22,.68,0,1.1), filter 0.6s ease';
      img.style.transform = 'rotateX(0deg) rotateY(0deg) scale(1)';
      if (shine) shine.style.background = 'radial-gradient(circle at 50% 50%, rgba(255,255,255,.04) 0%, transparent 60%)';
      setTimeout(() => { img.style.transition = 'transform 0.08s linear, filter 0.08s linear'; }, 620);
    });

    panel.addEventListener('touchmove', (e) => {
      if (!rect) rect = panel.getBoundingClientRect();
      const t = e.touches[0];
      const cx = rect.left + rect.width/2;
      const cy = rect.top + rect.height/2;
      const rx = Math.max(-MAX, Math.min(MAX, ((t.clientY - cy)/(rect.height/2))*-MAX));
      const ry = Math.max(-MAX, Math.min(MAX, ((t.clientX - cx)/(rect.width/2))*MAX));
      img.style.transform = `rotateX(${rx}deg) rotateY(${ry}deg) scale(1.03)`;
    }, { passive: true });
  })();

  /* ================== Reveal Cards ================== */
  (function initReveal() {
    const revEls = document.querySelectorAll('.r-up');
    if (!revEls.length) return;

    function showAll() { revEls.forEach(el => el.classList.add('on')); }

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver(entries => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            e.target.classList.add('on');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.05, rootMargin: '0px 0px -10px 0px' });

      revEls.forEach(el => io.observe(el));
      setTimeout(showAll, 1000);
    } else {
      showAll();
    }
  })();

  /* ================== Gallery + Lightbox ================== */
  // (function initGallery() {
  //   const galImg = document.getElementById('vp-gi');
  //   const galThs = document.querySelectorAll('.vp-gth');
  //   const galCount = document.getElementById('vp-gc');
  //   const lb = document.getElementById('tc-lb');
  //   const lbImg = document.getElementById('tc-lb-img');
  //   const lbX = document.getElementById('tc-lb-x');
  //   const gsrcs = [
  //     "https://cdn.shopify.com/s/files/1/0224/7891/3616/files/VIBEx-passport.png?v=1762844781",
  //     "https://cdn.shopify.com/s/files/1/0224/7891/3616/files/Photoroom_4.png?v=1762853147",
  //     "https://cdn.shopify.com/s/files/1/0224/7891/3616/files/VIBEx_Passport_kf.png?v=1762859964",
  //     "https://cdn.shopify.com/s/files/1/0224/7891/3616/files/VIBEx_Passport_-v.png?v=1762860068",
  //     "https://cdn.shopify.com/s/files/1/0224/7891/3616/files/2-Photoroom_2.png?v=1762937591",
  //     "https://cdn.shopify.com/s/files/1/0224/7891/3616/files/VIBEx_Passport_1.png?v=1762939864"
  //   ];

  //   if (!galImg || !galThs.length) return;

  //   function setGal(i) {
  //     galThs.forEach(b => b.classList.remove('on'));
  //     galThs[i].classList.add('on');
  //     galImg.style.opacity = '0';
  //     setTimeout(() => { galImg.src = gsrcs[i]; galImg.style.opacity = '1'; }, 200);
  //     if (galCount) galCount.textContent = `${i+1} / ${gsrcs.length}`;
  //   }

  //   galThs.forEach((t, i) => t.addEventListener('click', () => setGal(i)));

  //   const galMain = document.getElementById('vp-gm');
  //   if (galMain) {
  //     galMain.addEventListener('click', () => {
  //       if (lb && lbImg && galImg) {
  //         lbImg.src = galImg.src;
  //         lb.classList.add('on');
  //         document.body.style.overflow = 'hidden';
  //       }
  //     });
  //   }

  //   function closeLb() {
  //     if (lb) { 
  //       lb.classList.remove('on'); 
  //       document.body.style.overflow = '';
  //     }
  //   }

  //   if (lbX) lbX.addEventListener('click', closeLb);
  //   if (lb) lb.addEventListener('click', e => { if (e.target === lb) closeLb(); });
  //   document.addEventListener('keydown', e => { if (e.key === 'Escape') closeLb(); });
  // })();
(function () {

  document.querySelectorAll('.vp-gw').forEach(gallery => {

    const galImg = gallery.querySelector('.vp-gi');
    const galThs = gallery.querySelectorAll('.vp-gth');
    const galCount = gallery.querySelector('.vp-gc');

    const lb = document.getElementById('tc-lb');
    const lbImg = document.getElementById('tc-lb-img');
    const lbX = document.getElementById('tc-lb-x');

    // Read images directly from thumbnails
    const gsrcs = [...galThs].map(btn => btn.querySelector('img').src);

    function setGal(i) {
      galThs.forEach(t => t.classList.remove('on'));
      galThs[i].classList.add('on');

      galImg.style.opacity = '0';

      setTimeout(() => {
        galImg.src = gsrcs[i];
        galImg.style.opacity = '1';
      }, 200);

      if (galCount) {
        galCount.textContent = `${i + 1} / ${gsrcs.length}`;
      }
    }

    galThs.forEach((btn, i) => {
      btn.addEventListener('click', () => setGal(i));
    });

gallery.querySelector('.vp-gm').addEventListener('click', () => {
  if (!lb || !lbImg) {
    console.error('Lightbox elements not found');
    return;
  }

  lbImg.src = galImg.src;
  lb.classList.add('on');
  document.body.style.overflow = 'hidden';
});

  });

  const lb = document.getElementById('tc-lb');
  const lbImg = document.getElementById('tc-lb-img');
  const lbX = document.getElementById('tc-lb-x');

function closeLb() {
  if (!lb) return;

  lb.classList.remove('on');
  document.body.style.overflow = '';
}

if (lbX) {
  lbX.addEventListener('click', closeLb);
}

if (lb) {
  lb.addEventListener('click', e => {
    if (e.target === lb) closeLb();
  });
}

})();
})();


// Theta chamber page js

(() => {
  'use strict';

  /* ------------------ Scroll Reveal ------------------ */
  const initScrollReveal = () => {
    const els = document.querySelectorAll('.r-card');
    if (!els.length) return;

    if ('IntersectionObserver' in window) {
      const io = new IntersectionObserver((entries, observer) => {
        entries.forEach(entry => {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('on');
          observer.unobserve(entry.target);
        });
      }, {
        threshold: 0.08,
        rootMargin: '0px 0px -18px 0px'
      });

      els.forEach(el => io.observe(el));
    } else {
      els.forEach(el => el.classList.add('on'));
    }
  };

  /* ------------------ Gallery ------------------ */
  const initGallery = () => {
    const mainImg = document.querySelector('.tcg-main-img');
    const thumbs = [...document.querySelectorAll('.tcg-th')];
    const countEl = document.getElementById('tcg-count');
    const lb = document.getElementById('tc-lb');
    const lbImg = document.getElementById('tc-lb-img');
    const lbClose = document.getElementById('tc-lb-x');
    const main = document.getElementById('tcg-main');

    if (!thumbs.length || !mainImg) return;

    const srcs = [
      "https://cdn.shopify.com/s/files/1/0224/7891/3616/files/Theta_Chamber_3.jpg?v=1715102955",
      "https://cdn.shopify.com/s/files/1/0224/7891/3616/files/Theta_Chamber_4.jpg?v=1715102955",
      "https://cdn.shopify.com/s/files/1/0224/7891/3616/files/Theta_Chamber_6.jpg?v=1715102955",
      "https://cdn.shopify.com/s/files/1/0224/7891/3616/files/Theta_Chamber_1.jpg?v=1715102954",
      "https://cdn.shopify.com/s/files/1/0224/7891/3616/files/Theta_Chamber_2.jpg?v=1715102955",
      "https://cdn.shopify.com/s/files/1/0224/7891/3616/files/Theta_Chamber_5.jpg?v=1715102955"
    ];

    let currentIndex = 0;

    const updateGallery = (i) => {
      if (i < 0 || i >= srcs.length) return;

      currentIndex = i;

      thumbs.forEach(el => el.classList.remove('tcg-on'));
      thumbs[i]?.classList.add('tcg-on');

      mainImg.style.opacity = '0';
      setTimeout(() => {
        mainImg.src = srcs[i];
        mainImg.style.opacity = '1';
      }, 200);

      if (countEl) {
        countEl.textContent = `${i + 1} / ${srcs.length}`;
      }
    };

    thumbs.forEach((thumb, i) => {
      thumb.addEventListener('click', () => updateGallery(i));
    });

    /* Lightbox */
    const openLightbox = () => {
      if (!lb || !lbImg) return;
      lbImg.src = mainImg.src;
      lb.classList.add('on');
      document.body.style.overflow = 'hidden';
    };

    const closeLightbox = () => {
      if (!lb) return;
      lb.classList.remove('on');
      document.body.style.overflow = '';
    };

    main?.addEventListener('click', openLightbox);
    lbClose?.addEventListener('click', closeLightbox);

    lb?.addEventListener('click', (e) => {
      if (e.target === lb) closeLightbox();
    });

    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeLightbox();
    });

    updateGallery(0); // initialize
  };

  /* ------------------ FAQ Accordion ------------------ */
  const initFAQ = () => {
    const items = document.querySelectorAll('.tcf-item');
    if (!items.length) return;

    items.forEach(item => {
      item.addEventListener('toggle', () => {
        if (!item.open) return;

        items.forEach(other => {
          if (other !== item) other.removeAttribute('open');
        });
      });
    });
  };

  /* ------------------ Init All ------------------ */
  const init = () => {
    initScrollReveal();
    initGallery();
    initFAQ();
  };

  document.addEventListener('DOMContentLoaded', init);

})();

(function (global) {
  'use strict';

  const App = {
    init() {
      this.cacheDOM();
      if (!this.stage || !this.product) return;

      this.bindEvents();
      this.initObserver();
      this.initGallery();
      this.initFAQ();
    },

    cacheDOM() {
      this.stage   = document.getElementById('tch-stage');
      this.product = document.getElementById('tch-product');
      this.mainImg = document.getElementById('tch-img');
      this.shine   = document.getElementById('tch-shine');
      this.thumbs  = [...document.querySelectorAll('.tch-thumb')];

      this.revEls  = document.querySelectorAll('.r-card');

      // Gallery
      this.mainGallery = document.querySelector('.tcg-main-img');
      this.thumbsG     = document.querySelectorAll('.tcg-th');
      this.countEl     = document.getElementById('tcg-count');
      this.lb          = document.getElementById('tc-lb');
      this.lbImg       = document.getElementById('tc-lb-img');
      this.lbX         = document.getElementById('tc-lb-x');
      this.mainWrap    = document.getElementById('tcg-main');

      this.srcs = [
        "https://cdn.shopify.com/s/files/1/0224/7891/3616/files/Theta_Chamber_3.jpg?v=1715102955",
        "https://cdn.shopify.com/s/files/1/0224/7891/3616/files/Theta_Chamber_4.jpg?v=1715102955",
        "https://cdn.shopify.com/s/files/1/0224/7891/3616/files/Theta_Chamber_6.jpg?v=1715102955",
        "https://cdn.shopify.com/s/files/1/0224/7891/3616/files/Theta_Chamber_1.jpg?v=1715102954",
        "https://cdn.shopify.com/s/files/1/0224/7891/3616/files/Theta_Chamber_2.jpg?v=1715102955",
        "https://cdn.shopify.com/s/files/1/0224/7891/3616/files/Theta_Chamber_5.jpg?v=1715102955"
      ];

      this.rect = null;
      this.MAX = 12;
    },

    bindEvents() {
      this.stage.addEventListener('mousemove', this.onMove.bind(this));
      this.stage.addEventListener('mouseenter', this.onEnter.bind(this));
      this.stage.addEventListener('mouseleave', this.onLeave.bind(this));

      this.stage.addEventListener('touchmove', (e) => {
        e.preventDefault();
        this.onMove(e);
      }, { passive: false });

      this.initThumbs();
    },

    onMove(e) {
      if (!this.rect) this.rect = this.stage.getBoundingClientRect();

      const cx = this.rect.left + this.rect.width / 2;
      const cy = this.rect.top + this.rect.height / 2;

      const mx = e.clientX ?? e.touches?.[0]?.clientX ?? cx;
      const my = e.clientY ?? e.touches?.[0]?.clientY ?? cy;

      let rx = ((my - cy) / (this.rect.height / 2)) * -this.MAX;
      let ry = ((mx - cx) / (this.rect.width / 2)) * this.MAX;

      rx = Math.max(-this.MAX, Math.min(this.MAX, rx));
      ry = Math.max(-this.MAX, Math.min(this.MAX, ry));

      this.product.style.transform = `rotateX(${rx}deg) rotateY(${ry}deg)`;

      if (this.shine) {
        const sx = 20 + ((mx - this.rect.left) / this.rect.width) * 60;
        const sy = 20 + ((my - this.rect.top) / this.rect.height) * 60;

        this.shine.style.background =
          `radial-gradient(circle at ${sx}% ${sy}%, rgba(255,255,255,.06) 0%, transparent 55%)`;
      }
    },

    onEnter() {
      this.rect = this.stage.getBoundingClientRect();
      this.product.style.transition = 'transform 0.08s linear';
    },

    onLeave() {
      this.product.style.transition = 'transform 0.6s cubic-bezier(.22,.68,0,1.1)';
      this.product.style.transform  = 'rotateX(0deg) rotateY(0deg)';

      setTimeout(() => {
        this.product.style.transition = 'transform 0.08s linear';
      }, 620);

      if (this.shine) {
        this.shine.style.background =
          'radial-gradient(circle at 50% 50%, rgba(255,255,255,.04) 0%, transparent 65%)';
      }
    },

    initThumbs() {
      this.thumbs.forEach(btn => {
        btn.addEventListener('click', () => {
          this.thumbs.forEach(b => b.classList.remove('on'));
          btn.classList.add('on');

          if (this.mainImg && btn.dataset.src) {
            this.mainImg.style.opacity = '0';

            setTimeout(() => {
              this.mainImg.src = btn.dataset.src;
              this.mainImg.style.opacity = '1';
            }, 180);
          }

          this.rect = null;
        });
      });
    },

    initObserver() {
      if (!window.IntersectionObserver) {
        this.revEls.forEach(el => el.classList.add('on'));
        return;
      }

      const io = new IntersectionObserver((entries) => {
        entries.forEach(e => {
          if (e.isIntersecting) {
            e.target.classList.add('on');
            io.unobserve(e.target);
          }
        });
      }, { threshold: 0.08, rootMargin: '0px 0px -18px 0px' });

      this.revEls.forEach(el => io.observe(el));
    },

    initGallery() {
      if (!this.thumbsG.length) return;

      const setGallery = (i) => {
        this.thumbsG.forEach(b => b.classList.remove('tcg-on'));
        this.thumbsG[i].classList.add('tcg-on');

        if (this.mainGallery) {
          this.mainGallery.style.opacity = '0';
          setTimeout(() => {
            this.mainGallery.src = this.srcs[i];
            this.mainGallery.style.opacity = '1';
          }, 220);
        }

        if (this.countEl) {
          this.countEl.textContent = `${i + 1} / ${this.srcs.length}`;
        }
      };

      this.thumbsG.forEach((t, i) =>
        t.addEventListener('click', () => setGallery(i))
      );

      if (this.mainWrap) {
        this.mainWrap.addEventListener('click', () => {
          if (this.lb && this.lbImg && this.mainGallery) {
            this.lbImg.src = this.mainGallery.src;
            this.lb.classList.add('on');
            document.body.style.overflow = 'hidden';
          }
        });
      }

      const closeLb = () => {
        this.lb?.classList.remove('on');
        document.body.style.overflow = '';
      };

      this.lbX?.addEventListener('click', closeLb);
      this.lb?.addEventListener('click', e => {
        if (e.target === this.lb) closeLb();
      });

      document.addEventListener('keydown', e => {
        if (e.key === 'Escape') closeLb();
      });
    },

    initFAQ() {
      document.querySelectorAll('.tcf-item').forEach(d => {
        d.addEventListener('toggle', () => {
          if (d.open) {
            document.querySelectorAll('.tcf-item[open]').forEach(o => {
              if (o !== d) o.removeAttribute('open');
            });
          }
        });
      });
    }
  };

  // expose globally
  global.TCHApp = App;

  // auto init
  document.addEventListener('DOMContentLoaded', () => App.init());

})(window);


// js code for ora page
(() => {
  'use strict';

  /* ------------------ CONFIG ------------------ */
  const gsrcs = [
    "https://cdn.shopify.com/s/files/1/0224/7891/3616/files/ora.png?v=1750707023",
    "https://cdn.shopify.com/s/files/1/0224/7891/3616/files/Therapy_Device.png?v=1754126243",
    "https://cdn.shopify.com/s/files/1/0224/7891/3616/files/About_ora.png?v=1754128969",
    "https://cdn.shopify.com/s/files/1/0224/7891/3616/files/Targeted_Light.png?v=1754141123",
    "https://cdn.shopify.com/s/files/1/0224/7891/3616/files/LEO_Dome.png?v=1754141133",
    "https://cdn.shopify.com/s/files/1/0224/7891/3616/files/Li-PEMF_Coil.png?v=1754141134"
  ];

  const VIDEO_URL = 'VIDEO_URL_HERE';

  /* ------------------ DOM ------------------ */
  const $ = (sel) => document.querySelector(sel);
  const $$ = (sel) => document.querySelectorAll(sel);

  const galImg   = $('#ora-gi');
  const galThs   = $$('.ora-gth');
  const galCount = $('#ora-gc');
  const galMain  = $('#ora-gm');

  const lb    = $('#ora-lb');
  const lbImg = $('#ora-lb-img');
  const lbX   = $('#ora-lb-x');

  const vidWrap   = $('#ora-vid-wrap');
  const vidIframe = $('#ora-vid-iframe');

  const revEls = $$('.r-up, .r-fade');

  /* ------------------ GALLERY ------------------ */
  let currentIndex = 0;

  const setGal = (i) => {
    if (!galImg || !galThs.length) return;

    currentIndex = i;

    galThs.forEach(el => el.classList.remove('on'));
    galThs[i]?.classList.add('on');

    galImg.style.opacity = '0';

    setTimeout(() => {
      galImg.src = gsrcs[i];
      galImg.style.opacity = '1';
    }, 150);

    if (galCount) {
      galCount.textContent = `${i + 1} / ${gsrcs.length}`;
    }
  };

  galThs.forEach((el, i) => {
    el.addEventListener('click', () => setGal(i));
  });

  /* ------------------ LIGHTBOX ------------------ */
  const openLb = () => {
    if (!lb || !lbImg || !galImg) return;

    lbImg.src = galImg.src;
    lb.classList.add('on');
    document.body.style.overflow = 'hidden';
  };

  const closeLb = () => {
    if (!lb) return;

    lb.classList.remove('on');
    document.body.style.overflow = '';
  };

  galMain?.addEventListener('click', openLb);
  lbX?.addEventListener('click', closeLb);

  lb?.addEventListener('click', (e) => {
    if (e.target === lb) closeLb();
  });

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') closeLb();
  });

  /* ------------------ VIDEO ------------------ */
  vidWrap?.addEventListener('click', () => {
    if (vidWrap.classList.contains('playing')) return;

    if (VIDEO_URL && VIDEO_URL !== 'VIDEO_URL_HERE') {
      vidIframe.src = VIDEO_URL;
      vidWrap.classList.add('playing');
    }
  });

  /* ------------------ REVEAL ------------------ */
  const showAll = () => revEls.forEach(el => el.classList.add('on'));

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('on');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.05,
      rootMargin: '0px 0px -10px 0px'
    });

    revEls.forEach(el => io.observe(el));

    // Fallback in case observer delays
    setTimeout(showAll, 1000);

  } else {
    showAll();
  }

})();


// ==============================
// BLOG SEARCH + CLEAR BUTTON UX
// ==============================

document.addEventListener("DOMContentLoaded", function () {

  const searchInput = document.getElementById("bl-search");
  const clearBtn = document.getElementById("bl-sclear");
  const cards = document.querySelectorAll(".bl-card");
  const noResults = document.getElementById("bl-no-results");

  // Exit if not on blog page
  if (!searchInput || cards.length === 0) return;

  // Initially hide clear button
  if (clearBtn) clearBtn.style.display = "none";

  function filterArticles() {
    const query = searchInput.value.toLowerCase().trim();
    let visibleCount = 0;

    // Toggle clear button visibility
    if (clearBtn) {
      clearBtn.style.display = query.length > 0 ? "flex" : "none";
    }

    cards.forEach(card => {
      const title = card.dataset.title || "";
      const tags = card.dataset.tags || "";

      if (query === "" || title.includes(query) || tags.includes(query)) {
        card.style.display = "";
        visibleCount++;
      } else {
        card.style.display = "none";
      }
    });

    // Toggle "No results"
    if (noResults) {
      noResults.style.display = visibleCount === 0 ? "block" : "none";
    }
  }

  // Typing search
  searchInput.addEventListener("input", filterArticles);

  // Clear button click
  if (clearBtn) {
    clearBtn.addEventListener("click", function () {
      searchInput.value = "";
      filterArticles();
      searchInput.focus();
    });
  }

});

// collection search product js
// document.addEventListener("DOMContentLoaded", function () {

//   const searchInput = document.getElementById("col-search");
//   const clearBtn = document.getElementById("col-sclear");
//   const cards = document.querySelectorAll(".col-card");
//   const filters = document.querySelectorAll(".col-filt");
//   const countEl = document.getElementById("col-count");
//   const noResults = document.getElementById("col-no-results");

//   let activeFilter = "all";

//   function normalize(str) {
//     return str.toLowerCase().trim();
//   }

//   function filterProducts() {
//     const query = normalize(searchInput.value);
//     let visibleCount = 0;

//     cards.forEach(card => {
//       const name = normalize(card.dataset.name || "");
//       const tagsArray = (card.dataset.tags || "").split(",").map(normalize);

//       const matchSearch =
//         name.includes(query) ||
//         tagsArray.some(tag => tag.includes(query));

//       const matchFilter =
//         activeFilter === "all" ||
//         tagsArray.some(tag => tag === activeFilter);

//       if (matchSearch && matchFilter) {
//         card.style.display = "";
//         visibleCount++;
//       } else {
//         card.style.display = "none";
//       }
//     });

//     // update count
//     if (countEl) {
//       countEl.textContent = visibleCount + " products";
//     }

//     // toggle no results
//     if (noResults) {
//       noResults.style.display = visibleCount === 0 ? "block" : "none";
//     }

//     // toggle clear button
//     if (clearBtn) {
//       clearBtn.style.display = searchInput.value.trim() ? "flex" : "none";
//     }
//   }

//   // SEARCH
//   searchInput.addEventListener("input", filterProducts);

//   // CLEAR BUTTON
//   clearBtn.addEventListener("click", function () {
//     searchInput.value = "";
//     filterProducts();
//     searchInput.focus();
//   });

//   // FILTERS
//   filters.forEach(btn => {
//     btn.addEventListener("click", function () {
//       filters.forEach(b => b.classList.remove("active"));
//       this.classList.add("active");

//       activeFilter = normalize(this.dataset.filter);
//       filterProducts();
//     });
//   });

//   // INITIAL FILTER
//   filterProducts();

// });

document.addEventListener("DOMContentLoaded", function () {

  // ELEMENTS
  const searchInput = document.getElementById("col-search");
  const clearBtn = document.getElementById("col-sclear");
  const filters = document.querySelectorAll(".col-filt");
  const countEl = document.getElementById("col-pg-info"); // Product count info
  const noResults = document.getElementById("col-no-results");
  const productContainer = document.getElementById("col-grid");
  const otherResults = document.getElementById("col-other-results");
  const otherGrid = document.getElementById("col-other-grid");
  const prevBtn = document.getElementById("prev-page");
  const nextBtn = document.getElementById("next-page");
  const paginationNumbers = document.getElementById("pagination-numbers");
  const cfg = window.colSearchConfig || {};

  if (!searchInput || !productContainer) return;

  let allCards = Array.from(productContainer.querySelectorAll(".col-card"));
  let filteredCards = [];
  let activeFilter = "all";
  let currentPage = 1;
  const perPage = 12;
  let otherSearchTimer = null;
  let otherSearchToken = 0;

  // Normalize string
  function normalize(str) { return (str||"").toLowerCase().trim(); }

  // Strip spaces/hyphens/punctuation so "v max", "v-max", "vmax" all match
  function compact(str) {
    return normalize(str).replace(/[^a-z0-9]+/g, "");
  }

  function matchesFuzzy(haystack, needle) {
    if (!needle) return true;
    const h = normalize(haystack);
    const n = normalize(needle);
    if (!n) return true;
    if (h.includes(n)) return true;
    if (compact(h).includes(compact(n))) return true;

    // All tokens must appear (e.g. "v max" vs "V-Max Serum")
    const tokens = n.split(/[\s\-_+/]+/).filter(Boolean);
    if (tokens.length > 1) {
      const hc = compact(h);
      return tokens.every(t => h.includes(t) || hc.includes(compact(t)));
    }
    return false;
  }

  // Extra queries for Shopify API (it won't treat "vmax" as "v max" by itself)
  function queryVariants(q) {
    const n = normalize(q);
    if (!n) return [];
    const variants = new Set([n]);
    variants.add(n.replace(/[-_+/]+/g, " ").replace(/\s+/g, " ").trim());
    const c = compact(n);
    if (c) variants.add(c);
    // "vmax" → also try "v max"
    if (/^[a-z][a-z0-9]{2,}$/i.test(c)) {
      variants.add(c[0] + " " + c.slice(1));
    }
    return Array.from(variants).filter(Boolean);
  }

  function escapeHtml(str) {
    return String(str || "")
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function clearOtherResults() {
    otherSearchToken++;
    if (otherSearchTimer) clearTimeout(otherSearchTimer);
    if (otherGrid) otherGrid.innerHTML = "";
    if (otherResults) {
      otherResults.style.display = "none";
      otherResults.hidden = true;
    }
  }

  function productImageUrl(product) {
    if (product.image) return product.image;
    if (product.featured_image) {
      return typeof product.featured_image === "string"
        ? product.featured_image
        : (product.featured_image.url || "");
    }
    return "";
  }

  function formatPrice(price) {
    if (price == null || price === "") return "";
    const symbol = cfg.currencySymbol || "$";
    const num = Number(price);
    if (Number.isNaN(num)) return String(price);
    return symbol + num.toFixed(2);
  }

  function renderOtherProductCard(product) {
    const title = escapeHtml(product.title);
    const url = escapeHtml(product.url || ("/products/" + product.handle));
    const img = escapeHtml(productImageUrl(product));
    const desc = escapeHtml((product.body || "").replace(/<[^>]+>/g, "").slice(0, 120));
    const priceHtml = cfg.customerLoggedIn
      ? `<span class="col-price sale">${escapeHtml(formatPrice(product.price))}</span>`
      : `<a class="col-login-price" href="${escapeHtml(cfg.loginUrl || "/account/login")}">
           <svg viewBox="0 0 24 24"><rect x="3" y="11" width="18" height="11" rx="2"></rect><path d="M7 11V7a5 5 0 0 1 10 0v4"></path></svg>
           Login for price
         </a>`;

    return `
      <article class="col-card col-card-other r-up on" data-handle="${escapeHtml(product.handle)}">
        <div class="col-card-img">
          <a href="${url}" tabindex="-1">
            ${img ? `<img src="${img}" alt="${title}">` : ""}
          </a>
          <div class="col-card-overlay">
            <p class="col-card-overlay-desc">${desc}</p>
            <a href="${url}" class="col-card-overlay-btn">View Product</a>
          </div>
        </div>
        <div class="col-card-body">
          <a class="col-card-name" href="${url}">${title}</a>
          <p class="col-card-desc">${desc}</p>
          <div class="col-card-price">${priceHtml}</div>
          <span class="col-other-badge">Found in another collection</span>
        </div>
      </article>
    `;
  }

  function showOtherResults(products) {
    if (!otherResults || !otherGrid) return;
    if (!products.length) {
      otherGrid.innerHTML = "";
      otherResults.style.display = "none";
      otherResults.hidden = true;
      if (noResults) noResults.style.display = "block";
      return;
    }

    otherGrid.innerHTML = products.map(renderOtherProductCard).join("");
    otherResults.style.display = "block";
    otherResults.hidden = false;
    if (noResults) noResults.style.display = "none";
  }

  // Search store-wide via Shopify Predictive Search when current collection has no matches
  function searchOtherCollections(query) {
    if (!otherResults || !otherGrid) return;

    const token = ++otherSearchToken;
    const currentHandles = new Set(
      allCards.map(card => normalize(card.dataset.handle)).filter(Boolean)
    );

    const variants = queryVariants(query);
    const fetches = variants.map(q => {
      const params = new URLSearchParams({
        q: q,
        "resources[type]": "product",
        "resources[limit]": "12",
        "resources[options][unavailable_products]": "last"
      });
      return fetch("/search/suggest.json?" + params.toString())
        .then(res => res.ok ? res.json() : { resources: { results: { products: [] } } })
        .catch(() => ({ resources: { results: { products: [] } } }));
    });

    Promise.all(fetches)
      .then(results => {
        if (token !== otherSearchToken) return;

        const seen = new Set();
        const products = [];

        results.forEach(data => {
          (((data.resources || {}).results || {}).products || []).forEach(p => {
            if (!p || !p.handle) return;
            const handle = normalize(p.handle);
            if (currentHandles.has(handle) || seen.has(handle)) return;
            // Keep only products that fuzzy-match the typed query
            if (!matchesFuzzy(p.title || "", query) && !matchesFuzzy(p.handle || "", query)) return;
            seen.add(handle);
            products.push(p);
          });
        });

        showOtherResults(products.slice(0, 12));
      })
      .catch(() => {
        if (token !== otherSearchToken) return;
        clearOtherResults();
        if (noResults) noResults.style.display = "block";
      });
  }

  // 🔹 Apply search + filter
  function applyFiltersAndSearch() {
    const query = normalize(searchInput.value);

    filteredCards = allCards.filter(card => {
      const name = card.dataset.name || "";
      const handle = card.dataset.handle || "";
      const tags = (card.dataset.tags || "").split(",");

      const matchesSearch = !query
        || matchesFuzzy(name, query)
        || matchesFuzzy(handle, query)
        || tags.some(tag => matchesFuzzy(tag, query));
      const matchesFilter = activeFilter === "all" || tags.map(normalize).includes(activeFilter);

      return matchesSearch && matchesFilter;
    });

    currentPage = 1;
    renderPage();
    updatePagination();

    // If nothing in this collection matches, search other collections
    if (query && filteredCards.length === 0) {
      if (otherSearchTimer) clearTimeout(otherSearchTimer);
      otherSearchTimer = setTimeout(() => searchOtherCollections(query), 280);
    } else {
      clearOtherResults();
    }

    // Show/hide clear button
    if(clearBtn) clearBtn.style.display = searchInput.value.trim() ? "flex" : "none";
  }

  // 🔹 Render products for current page
  function renderPage() {
    allCards.forEach(card => card.style.display = "none");

    const totalProducts = filteredCards.length;
    const startIndex = (currentPage - 1) * perPage;
    const endIndex = Math.min(startIndex + perPage, totalProducts);

    const pageCards = filteredCards.slice(startIndex, endIndex);
    pageCards.forEach(card => card.style.display = "");

    // Update product count
    if(countEl) {
      if(totalProducts <= perPage) {
        countEl.style.display = "none";  // hide product count if ≤ perPage
      } else {
        countEl.style.display = "block";
        countEl.textContent = `Showing ${startIndex + 1}–${endIndex} of ${totalProducts} products`;
      }
    }

    // Only show hard "no results" when there is no query (other-collection search handles query misses)
    const query = normalize(searchInput.value);
    if (noResults) {
      noResults.style.display = (totalProducts === 0 && !query) ? "block" : "none";
    }
  }

  // 🔹 Update pagination numbers
  function updatePagination() {
    const totalPages = Math.ceil(filteredCards.length / perPage);

    // Hide entire pagination if only 1 page or no products
  const paginationContainer = document.getElementById("col-pagination");
  if(paginationContainer) {
    paginationContainer.style.display = totalPages <= 1 ? "none" : "flex";
  }

    if (paginationNumbers) {
      paginationNumbers.innerHTML = "";
      for (let i = 1; i <= totalPages; i++) {
        const btn = document.createElement("button");
        btn.className = "col-pg-btn" + (i === currentPage ? " active" : "");
        btn.textContent = i;
        btn.addEventListener("click", () => { currentPage = i; renderPage(); updatePagination(); });
        paginationNumbers.appendChild(btn);
      }
    }

    if (prevBtn) prevBtn.disabled = currentPage <= 1;
    if (nextBtn) nextBtn.disabled = currentPage >= totalPages || totalPages === 0;
  }

  // 🔹 Pagination arrows
  if (prevBtn) {
    prevBtn.addEventListener("click", () => {
      if(currentPage > 1) { currentPage--; renderPage(); updatePagination(); }
    });
  }
  if (nextBtn) {
    nextBtn.addEventListener("click", () => {
      const totalPages = Math.ceil(filteredCards.length / perPage);
      if(currentPage < totalPages) { currentPage++; renderPage(); updatePagination(); }
    });
  }

  // 🔹 Search input
  searchInput.addEventListener("input", applyFiltersAndSearch);

  // 🔹 Clear button
  if (clearBtn) {
    clearBtn.addEventListener("click", function() {
      searchInput.value = "";
      activeFilter = "all";

      filters.forEach(b => b.classList.remove("active"));
      const allBtn = document.querySelector('.col-filt[data-filt="all"]');
      if(allBtn) allBtn.classList.add("active");

      applyFiltersAndSearch();
      searchInput.focus();
    });
  }

  // 🔹 Filter buttons
  // filters.forEach(btn => {
  //   btn.addEventListener("click", function() {
  //     filters.forEach(b => b.classList.remove("active"));
  //     this.classList.add("active");
  //     activeFilter = normalize(this.dataset.filt);
  //     applyFiltersAndSearch();
  //   });
  // });

  // 🔹 INITIALIZE
  applyFiltersAndSearch();

});

// Educational Information page js 
(function () {
  function initGlobalScripts() {

    /* =========================
       Reveal (safe)
    ========================= */
    var revEls = document.querySelectorAll('.r-up');
    if (revEls.length) {
      function showAll() {
        revEls.forEach(function (e) { e.classList.add('on'); });
      }

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              e.target.classList.add('on');
              io.unobserve(e.target);
            }
          });
        }, { threshold: 0.05, rootMargin: '0px 0px -8px 0px' });

        revEls.forEach(function (el) { io.observe(el); });
        setTimeout(showAll, 1000);
      } else {
        showAll();
      }
    }

    /* =========================
       Video Lightbox (safe)
    ========================= */
    var lb = document.getElementById('ei-vid-lb');
    var lbIf = document.getElementById('ei-vid-iframe');
    var lbX = document.getElementById('ei-vid-lb-x');

    if (lb && lbIf) {
      function openVideo(embed) {
        lbIf.src = embed;
        lb.classList.add('on');
        document.body.style.overflow = 'hidden';
      }

      function closeVideo() {
        lb.classList.remove('on');
        lbIf.src = '';
        document.body.style.overflow = '';
      }

      document.querySelectorAll('.ei-vid-card').forEach(function (card) {
        card.addEventListener('click', function () {
          openVideo(card.dataset.embed);
        });

        card.setAttribute('tabindex', '0');
        card.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            openVideo(card.dataset.embed);
          }
        });
      });

      if (lbX) lbX.addEventListener('click', closeVideo);
      lb.addEventListener('click', function (e) {
        if (e.target === lb) closeVideo();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeVideo();
      });
    }

    /* =========================
       Filter + Search (safe)
    ========================= */
    var search = document.getElementById('ei-search');
    var sclear = document.getElementById('ei-sclear');

    if (search) {
      var filts = document.querySelectorAll('.ei-filt');
      var pdfCards = document.querySelectorAll('.ei-card');
      var vidCards = document.querySelectorAll('.ei-vid-card');

      var countEl = document.getElementById('ei-count');
      var pdfCt = document.getElementById('ei-pdf-count');
      var vidCt = document.getElementById('ei-vid-count');

      var pdfHead = document.getElementById('ei-pdf-head');
      var vidHead = document.getElementById('ei-vid-head');
      var pdfGrid = document.getElementById('ei-pdf-grid');
      var vidGrid = document.getElementById('ei-vid-grid');

      var pdfNoRes = document.getElementById('ei-pdf-no-results');
      var vidNoRes = document.getElementById('ei-vid-no-results');

      var curFilt = 'all';

      function update() {
        var q = search.value.toLowerCase().trim();
        var pv = 0, vv = 0;

        pdfCards.forEach(function (c) {
          var match =
            (!q || (c.dataset.name || '').includes(q)) &&
            (curFilt === 'all' || c.dataset.cat === curFilt);

          c.classList.toggle('hidden', !match);
          if (match) pv++;
        });

        vidCards.forEach(function (c) {
          var match =
            (!q || (c.dataset.name || '').includes(q)) &&
            (curFilt === 'all' || c.dataset.cat === curFilt);

          c.classList.toggle('hidden', !match);
          if (match) vv++;
        });

        if (pdfCt) pdfCt.textContent = pv;
        if (vidCt) vidCt.textContent = vv;
        if (countEl) {
          countEl.textContent =
            (pv + vv) + ' resource' + (pv + vv !== 1 ? 's' : '');
        }

        if (pdfNoRes) {
          pdfNoRes.classList.toggle('seen', pv === 0 && curFilt !== 'video');
        }

        if (vidNoRes) {
          vidNoRes.classList.toggle(
            'seen',
            vv === 0 && curFilt !== 'nls research' && curFilt !== 'ao scan'
          );
        }

        if (pdfHead) pdfHead.style.display = (curFilt === 'video') ? 'none' : '';
        if (pdfGrid) pdfGrid.style.display = (curFilt === 'video') ? 'none' : '';
        if (vidHead) vidHead.style.display =
          (curFilt === 'nls research' || curFilt === 'ao scan') ? 'none' : '';
        if (vidGrid) vidGrid.style.display =
          (curFilt === 'nls research' || curFilt === 'ao scan') ? 'none' : '';

        if (sclear) sclear.classList.toggle('seen', q.length > 0);
      }

      filts.forEach(function (btn) {
        btn.addEventListener('click', function () {
          filts.forEach(function (b) { b.classList.remove('active'); });
          btn.classList.add('active');
          curFilt = btn.dataset.filt;
          update();
        });
      });

      search.addEventListener('input', update);

      if (sclear) {
        sclear.addEventListener('click', function () {
          search.value = '';
          sclear.classList.remove('seen');
          update();
          search.focus();
        });
      }
    }

    /* =========================
       Drag Scroll (safe)
    ========================= */
    var strip = document.getElementById('ei-filts');
    if (strip) {
      var dragging = false, startX = 0, startScroll = 0;

      strip.addEventListener('mousedown', function (e) {
        dragging = true;
        startX = e.pageX;
        startScroll = strip.scrollLeft;
        strip.classList.add('dragging');
        e.preventDefault();
      });

      document.addEventListener('mouseup', function () {
        dragging = false;
        strip.classList.remove('dragging');
      });

      document.addEventListener('mousemove', function (e) {
        if (!dragging) return;
        strip.scrollLeft = startScroll - (e.pageX - startX) * 1.2;
      });
    }
  }

  /* ✅ Run safely on all pages */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initGlobalScripts);
  } else {
    initGlobalScripts();
  }
})();

// Page title js

document.addEventListener("DOMContentLoaded", () => {
  const applyDynamicTitle = () => {
    const titles = document.querySelectorAll(".cl-h1");

    titles.forEach(title => {
      // Avoid re-processing
      if (title.classList.contains("processed")) return;

      const text = title.textContent.trim();
      const words = text.split(/\s+/);

      if (words.length > 1) {
        const firstWord = words.shift();
        const rest = words.join(" ");

        title.innerHTML = `<em>${firstWord}</em> ${rest}`;
        title.classList.add("processed");
      }
    });
  };

  applyDynamicTitle();
});


// cart page js
// document.addEventListener('DOMContentLoaded', function() {

//   window.Shopify = window.Shopify || {};
//   Shopify.formatMoney = Shopify.formatMoney || function(cents) {
//     return '$' + (cents / 100).toFixed(2);
//   };

//   // ===== Toggle Checkout Button =====
//   function toggleCheckoutButton(itemCount) {
//     var checkoutBtn = document.querySelector('.cart-checkout-btn');
//     if (!checkoutBtn) return;

//     if (itemCount === 0) {
//       checkoutBtn.classList.add('disabled');
//       checkoutBtn.style.opacity = '0.5';
//       checkoutBtn.style.cursor = 'not-allowed';
//       checkoutBtn.setAttribute('data-href', checkoutBtn.getAttribute('href')); // store original link
//       checkoutBtn.removeAttribute('href');

//       // prevent click
//       checkoutBtn.onclick = function(e) {
//         e.preventDefault();
//       };

//     } else {
//       checkoutBtn.classList.remove('disabled');
//       checkoutBtn.style.opacity = '1';
//       checkoutBtn.style.cursor = 'pointer';

//       // restore link if missing
//       if (!checkoutBtn.getAttribute('href')) {
//         var original = checkoutBtn.getAttribute('data-href') || '/checkout';
//         checkoutBtn.setAttribute('href', original);
//       }

//       checkoutBtn.onclick = null;
//     }
//   }

//   // ===== Refresh cart + header =====
//   function refreshCart() {
//     fetch('/cart.js')
//       .then(res => res.json())
//       .then(cart => {
//         // --- Header updates ---
//         var badge = document.querySelector('.cart-badge');
//         if (badge) badge.textContent = cart.item_count;

//         var hdrCt = document.getElementById('hdr-ct');
//         if (hdrCt) hdrCt.textContent = cart.item_count;

//         // --- Cart page totals ---
//         var sumSubtotal = document.getElementById('sum-subtotal');
//         var sumTotal = document.getElementById('sum-total');
//         var sumCt = document.getElementById('sum-ct');

//         if (sumSubtotal) sumSubtotal.textContent = Shopify.formatMoney(cart.total_price);
//         if (sumTotal) sumTotal.textContent = Shopify.formatMoney(cart.total_price);
//         if (sumCt) sumCt.textContent = cart.item_count;

//         // --- Update cart rows ---
//         cart.items.forEach((item, index) => {
//           var rowTotal = document.getElementById('row-total-' + index);
//           if (rowTotal) rowTotal.textContent = Shopify.formatMoney(item.line_price);

//           var input = document.querySelector(`[data-id="${item.key}"] .cart-qty-val`);
//           if (input) input.value = item.quantity;
//         });

//         // --- Empty cart handling ---
//         var empty = document.getElementById('cart-empty');
//         if (empty) empty.classList.toggle('show', cart.item_count === 0);

//         // ✅ Handle checkout button state
//         toggleCheckoutButton(cart.item_count);

//         // --- Remove deleted rows ---
//         document.querySelectorAll('.cart-row').forEach(row => {
//           var key = row.dataset.id;
//           if (!cart.items.find(i => i.key === key)) row.remove();
//         });

//         console.log('Cart refreshed:', cart.item_count);
//       })
//       .catch(err => console.error('Cart fetch error:', err));
//   }

//   // ===== Quantity change =====
//   window.changeQty = function(btn, delta) {
//     var wrap = btn.closest('.cart-row');
//     var inp  = wrap.querySelector('.cart-qty-val');
//     var newQty = Math.max(0, parseInt(inp.value) + delta);
//     updateQuantity(wrap.dataset.id, newQty);
//   };

//   // ===== Update quantity via AJAX =====
//   window.updateQuantity = function(key, quantity) {
//     fetch('/cart/change.js', {
//       method: 'POST',
//       headers: {'Content-Type': 'application/json'},
//       body: JSON.stringify({id: key, quantity: quantity})
//     })
//     .then(res => res.json())
//     .then(() => refreshCart());
//   };

//   // ===== Remove item =====
//   window.removeItem = function(btn) {
//     var row = btn.closest('.cart-row');
//     var key = row.dataset.id;
//     row.style.transition = 'opacity .28s, transform .28s';
//     row.style.opacity = '0';
//     row.style.transform = 'translateX(-16px)';
//     setTimeout(() => {
//       fetch('/cart/change.js', {
//         method: 'POST',
//         headers: {'Content-Type': 'application/json'},
//         body: JSON.stringify({id: key, quantity: 0})
//       })
//       .then(res => res.json())
//       .then(() => refreshCart());
//     }, 280);
//   };

//   // ===== Optional manual update button =====
//   window.updateCart = function() {
//     refreshCart();
//     var btn = document.querySelector('.cart-update-btn');
//     if (!btn) return;
//     var orig = btn.innerHTML;
//     btn.innerHTML = '<svg viewBox="0 0 24 24" width="13" height="13" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round"><polyline points="20 6 9 17 4 12"/></svg> Cart Updated';
//     btn.style.color = '#3a6a0a';
//     btn.style.borderColor = '#3a6a0a';
//     setTimeout(() => { btn.innerHTML = orig; btn.style.color=''; btn.style.borderColor=''; }, 2000);
//   };

//   // ===== Initial load =====
//   refreshCart();

// });

document.addEventListener('DOMContentLoaded', function() {

  window.Shopify = window.Shopify || {};
  Shopify.formatMoney = Shopify.formatMoney || function(cents) {
    return '$' + (cents / 100).toFixed(2);
  };

  // ===== Toggle Checkout + Update Buttons =====
  function toggleButtons(itemCount) {
    var checkoutBtn = document.querySelector('.cart-checkout-btn');
    var updateBtn = document.querySelector('.cart-update-btn');

    var disable = itemCount === 0;

    // ===== Checkout Button =====
    if (checkoutBtn) {
      if (disable) {
        checkoutBtn.classList.add('disabled');
        checkoutBtn.style.opacity = '0.5';
        checkoutBtn.style.cursor = 'not-allowed';
        checkoutBtn.setAttribute('data-href', checkoutBtn.getAttribute('href'));
        checkoutBtn.removeAttribute('href');
        checkoutBtn.onclick = function(e) { e.preventDefault(); };
      } else {
        checkoutBtn.classList.remove('disabled');
        checkoutBtn.style.opacity = '1';
        checkoutBtn.style.cursor = 'pointer';
        if (!checkoutBtn.getAttribute('href')) {
          var original = checkoutBtn.getAttribute('data-href') || '/checkout';
          checkoutBtn.setAttribute('href', original);
        }
        checkoutBtn.onclick = null;
      }
    }

    // ===== Update Cart Button =====
    if (updateBtn) {
      updateBtn.disabled = disable;
      updateBtn.style.opacity = disable ? '0.5' : '1';
      updateBtn.style.cursor = disable ? 'not-allowed' : 'pointer';
    }
  }

  // ===== Refresh cart + header =====
  function refreshCart() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        // Header updates
        var badge = document.querySelector('.cart-badge');
        if (badge) badge.textContent = cart.item_count;
        var hdrCt = document.getElementById('hdr-ct');
        if (hdrCt) hdrCt.textContent = cart.item_count;

        // Cart totals
        var sumSubtotal = document.getElementById('sum-subtotal');
        var sumTotal = document.getElementById('sum-total');
        var sumCt = document.getElementById('sum-ct');

        if (sumSubtotal) sumSubtotal.textContent = Shopify.formatMoney(cart.total_price);
        if (sumTotal) sumTotal.textContent = Shopify.formatMoney(cart.total_price);
        if (sumCt) sumCt.textContent = cart.item_count;

        // Update cart rows
        cart.items.forEach((item, index) => {
          var rowTotal = document.getElementById('row-total-' + index);
          if (rowTotal) rowTotal.textContent = Shopify.formatMoney(item.line_price);

          var input = document.querySelector(`[data-id="${item.key}"] .cart-qty-val`);
          if (input) input.value = item.quantity;
        });

        // Empty cart handling
        var empty = document.getElementById('cart-empty');
        if (empty) empty.classList.toggle('show', cart.item_count === 0);

        // 🔹 Toggle buttons dynamically
        toggleButtons(cart.item_count);

        // Remove deleted rows
        document.querySelectorAll('.cart-row').forEach(row => {
          var key = row.dataset.id;
          if (!cart.items.find(i => i.key === key)) row.remove();
        });

        console.log('Cart refreshed:', cart.item_count);
      })
      .catch(err => console.error('Cart fetch error:', err));
  }

  // ===== Quantity change (+ / - buttons) =====
  window.changeQty = function(btn, delta) {
    var wrap = btn.closest('.cart-row');
    var inp  = wrap.querySelector('.cart-qty-val');
    var newQty = Math.max(0, parseInt(inp.value) + delta);
    inp.value = newQty;
    updateQuantity(wrap.dataset.id, newQty);
  };

  // ===== Update quantity via AJAX =====
  window.updateQuantity = function(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({id: key, quantity: quantity})
    })
    .then(res => res.json())
    .then(() => refreshCart())
    .catch(err => console.error('Quantity update error:', err));
  };

  // ===== Remove item =====
  window.removeItem = function(btn) {
    var row = btn.closest('.cart-row');
    var key = row.dataset.id;
    row.style.transition = 'opacity .28s, transform .28s';
    row.style.opacity = '0';
    row.style.transform = 'translateX(-16px)';
    setTimeout(() => {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json'},
        body: JSON.stringify({id: key, quantity: 0})
      })
      .then(res => res.json())
      .then(() => refreshCart())
      .catch(err => console.error('Remove item error:', err));
    }, 280);
  };

  // ===== Manual input changes (highlight update button) =====
  document.addEventListener('input', function(e) {
    if (e.target.classList.contains('cart-qty-val')) {
      var btn = document.querySelector('.cart-update-btn');
      if (btn) {
        btn.style.opacity = '1';
        btn.style.background = '#000';
        btn.style.color = '#fff';
      }
    }
  });

  // ===== Update Cart button (manual input) =====
  window.updateCart = function() {
    var updates = {};
    document.querySelectorAll('.cart-row').forEach(row => {
      var key = row.dataset.id;
      var input = row.querySelector('.cart-qty-val');
      var qty = parseInt(input.value);
      if (!isNaN(qty)) updates[key] = qty;
    });

    fetch('/cart/update.js', {
      method: 'POST',
      headers: {'Content-Type': 'application/json'},
      body: JSON.stringify({ updates: updates })
    })
    .then(res => res.json())
    .then(() => {
      refreshCart();

      var btn = document.querySelector('.cart-update-btn');
      if (!btn) return;

      var orig = btn.innerHTML;

      // 🔹 Button text + color update
      btn.innerHTML = '✔ Cart Updated';
      btn.style.background = '#020810';
      btn.style.color = '#fff';
      btn.style.borderColor = '#3a6a0a';

      // 🔹 Reset after 2 seconds
      setTimeout(() => {
        btn.innerHTML = orig;
        btn.style.color = '';
        btn.style.background = '';
        btn.style.borderColor = '';
      }, 2000);
    })
    .catch(err => console.error('Update cart error:', err));
  };

  // ===== Initial load =====
  refreshCart();

});

// single product template page js
(function () {
  "use strict";

  const $ = (s) => document.querySelector(s);
  const $$ = (s) => document.querySelectorAll(s);

  // ===== Breadcrumb Reverse Scroll =====
  const breadcrumbs = $(".pd-bc");
  const bcMove = "moVedw";
  if (breadcrumbs) {
    breadcrumbs.classList.add(bcMove);
    window.addEventListener("scroll", () => {
      if (window.scrollY > 40) {
        breadcrumbs.classList.remove(bcMove);
      } else {
        breadcrumbs.classList.add(bcMove);
      }
    });
  }

  // ===== Reveal Animation =====
  $$(".r-up").forEach(el => el.classList.add("on"));

  // ===== PRODUCT GALLERY & ZOOM =====
  const mainPhoto = $('#pd-main-photo');
  const imgWrap = $('#pd-img-wrap');
  const zoomLens = $('#pd-zoom-lens');
  const zoomResult = $('#pd-zoom-result');
  const zoomImg = $('#pd-zoom-img');

  // if (mainPhoto && imgWrap) {
  //   const ZOOM_SCALE = 2.8;

  //   $$('.pd-thumb').forEach((thumb) => {
  //     thumb.addEventListener('click', () => {
  //       $$('.pd-thumb').forEach(t => t.classList.remove('active'));
  //       thumb.classList.add('active');
  //       mainPhoto.style.opacity = '0';
  //       setTimeout(() => {
  //         mainPhoto.src = thumb.dataset.src;
  //         if (zoomImg) zoomImg.src = thumb.dataset.src;
  //         mainPhoto.style.opacity = '1';
  //       }, 160);
  //     });
  //   });

  //   if (zoomLens && zoomResult && zoomImg) {
  //     function updateZoom(e) {
  //       const rect = imgWrap.getBoundingClientRect();
  //       const lw = zoomLens.offsetWidth;
  //       const lh = zoomLens.offsetHeight;
  //       const rw = zoomResult.offsetWidth;
  //       const rh = zoomResult.offsetHeight;

  //       let cx = e.clientX - rect.left;
  //       let cy = e.clientY - rect.top;

  //       let lx = Math.max(0, Math.min(cx - lw / 2, rect.width - lw));
  //       let ly = Math.max(0, Math.min(cy - lh / 2, rect.height - lh));

  //       zoomLens.style.left = lx + 'px';
  //       zoomLens.style.top = ly + 'px';

  //       let zw = rect.width * ZOOM_SCALE;
  //       let zh = rect.height * ZOOM_SCALE;

  //       zoomImg.style.width = zw + 'px';
  //       zoomImg.style.height = zh + 'px';

  //       let rx = -(lx / rect.width) * zw + rw / 2 - (lw / 2 * ZOOM_SCALE);
  //       let ry = -(ly / rect.height) * zh + rh / 2 - (lh / 2 * ZOOM_SCALE);

  //       rx = Math.min(0, Math.max(rw - zw, rx));
  //       ry = Math.min(0, Math.max(rh - zh, ry));

  //       zoomImg.style.left = rx + 'px';
  //       zoomImg.style.top = ry + 'px';
  //     }

  //     imgWrap.addEventListener('mouseenter', () => {
  //       if (window.innerWidth <= 1024) return;
  //       zoomImg.src = mainPhoto.src;
  //       zoomLens.style.display = 'block';
  //       zoomResult.style.display = 'block';
  //     });

  //     imgWrap.addEventListener('mousemove', updateZoom);

  //     imgWrap.addEventListener('mouseleave', () => {
  //       zoomLens.style.display = 'none';
  //       zoomResult.style.display = 'none';
  //     });
  //   }
  // }
if (mainPhoto && imgWrap) {
  const ZOOM_SCALE = 2.8;

  // Keep the high-resolution zoom URL on the main image
  if (mainPhoto.dataset.zoom) {
    zoomImg.src = mainPhoto.dataset.zoom;
  }

  // ===== THUMBNAIL CLICK =====
  $$('.pd-thumb').forEach((thumb) => {
    thumb.addEventListener('click', () => {

      $$('.pd-thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');

      const normalSrc = thumb.dataset.src;
      const zoomSrc = thumb.dataset.zoom || normalSrc;

      mainPhoto.style.opacity = '0';

      setTimeout(() => {

        // Normal gallery image
        mainPhoto.src = normalSrc;

        // High-resolution image for zoom
        mainPhoto.dataset.zoom = zoomSrc;

        if (zoomImg) {
          zoomImg.src = zoomSrc;
        }

        mainPhoto.style.opacity = '1';

      }, 160);
    });
  });

  // ===== ZOOM =====
  if (zoomLens && zoomResult && zoomImg) {

    function updateZoom(e) {

      const rect = imgWrap.getBoundingClientRect();

      const lw = zoomLens.offsetWidth;
      const lh = zoomLens.offsetHeight;

      const rw = zoomResult.offsetWidth;
      const rh = zoomResult.offsetHeight;

      let cx = e.clientX - rect.left;
      let cy = e.clientY - rect.top;

      let lx = Math.max(
        0,
        Math.min(cx - lw / 2, rect.width - lw)
      );

      let ly = Math.max(
        0,
        Math.min(cy - lh / 2, rect.height - lh)
      );

      zoomLens.style.left = lx + 'px';
      zoomLens.style.top = ly + 'px';

      /*
       * Zoom container dimensions.
       * The actual image source is now the high-resolution
       * 3000px version instead of the 1000px gallery image.
       */
      let zw = rect.width * ZOOM_SCALE;
      let zh = rect.height * ZOOM_SCALE;

      zoomImg.style.width = zw + 'px';
      zoomImg.style.height = zh + 'px';

      let rx =
        -(lx / rect.width) * zw +
        rw / 2 -
        (lw / 2 * ZOOM_SCALE);

      let ry =
        -(ly / rect.height) * zh +
        rh / 2 -
        (lh / 2 * ZOOM_SCALE);

      rx = Math.min(
        0,
        Math.max(rw - zw, rx)
      );

      ry = Math.min(
        0,
        Math.max(rh - zh, ry)
      );

      zoomImg.style.left = rx + 'px';
      zoomImg.style.top = ry + 'px';
    }

    // ===== MOUSE ENTER =====
    imgWrap.addEventListener('mouseenter', () => {

      // Don't use zoom on tablet/mobile
      if (window.innerWidth <= 1024) return;

      // IMPORTANT:
      // Use the high-resolution zoom image,
      // NOT mainPhoto.src
      zoomImg.src =
        mainPhoto.dataset.zoom || mainPhoto.src;

      zoomLens.style.display = 'block';
      zoomResult.style.display = 'block';
    });

    // ===== MOUSE MOVE =====
    imgWrap.addEventListener('mousemove', updateZoom);

    // ===== MOUSE LEAVE =====
    imgWrap.addEventListener('mouseleave', () => {

      zoomLens.style.display = 'none';
      zoomResult.style.display = 'none';

    });
  }
}
  // ===== QTY + PRICE =====
  const qtyEl = $('#pd-qty');
  const minus = $('#pd-qty-minus');
  const plus = $('#pd-qty-plus');

  const realQtyInput = document.querySelector('input[name="quantity"]');

  // IMPORTANT FIX
  const variantInput = document.querySelector('#pd-form-variant');

  const priceEl = $('.pd-price .hidePrice');
  const compareEl = $('.pd-compare .hidePrice');

  let selectedVariant = null;

  // ===== STORE BASE PRICE =====
  const basePrice = priceEl
    ? parseFloat(priceEl.textContent.replace(/[^0-9.]/g, '')) || 0
    : 0;

  const baseCompare = compareEl
    ? parseFloat(compareEl.textContent.replace(/[^0-9.]/g, '')) || 0
    : 0;

  function updatePrice() {
    let qty = parseInt(qtyEl.value);

    if (isNaN(qty) || qty < 1) qty = 1;

    qtyEl.value = qty;

    if (selectedVariant) {

      const mainPrice = (selectedVariant.price / 100) * qty;
      priceEl.textContent = '$' + mainPrice.toFixed(2);

      if (
        selectedVariant.compare_at_price &&
        Number(selectedVariant.compare_at_price) > 0
      ) {

        compareEl.textContent =
          '$' +
          (
            Number(selectedVariant.compare_at_price) / 100 * qty
          ).toFixed(2);

        compareEl.parentElement.style.display = 'inline';

      } else {

        compareEl.textContent = '';
        compareEl.parentElement.style.display = 'none';
      }

    } else {

      const mainPrice = basePrice * qty;
      priceEl.textContent = '$' + mainPrice.toFixed(2);

      if (baseCompare > 0) {

        compareEl.textContent =
          '$' + (baseCompare * qty).toFixed(2);

        compareEl.parentElement.style.display = 'inline';

      } else {

        compareEl.textContent = '';
        compareEl.parentElement.style.display = 'none';
      }
    }

    if (realQtyInput) {
      realQtyInput.value = qty;
    }
  }

  function changeQty(amount) {
    let qty = parseInt(qtyEl.value) || 1;

    qty += amount;
    qty = Math.max(1, Math.min(99, qty));

    qtyEl.value = qty;

    updatePrice();
  }

  if (qtyEl) {

    minus.addEventListener('click', () => changeQty(-1));

    plus.addEventListener('click', () => changeQty(1));

    qtyEl.addEventListener('input', updatePrice);
  }

  // ===== VARIANT BUTTON LOGIC =====
  $$('.pd-size').forEach(btn => {

    btn.addEventListener('click', () => {

      $$('.pd-size').forEach(b => b.classList.remove('active'));

      btn.classList.add('active');

      const variantId = btn.getAttribute('data-variant-id');

      if (!variantId || !window.productVariants) return;

      selectedVariant = productVariants.find(v => v.id == variantId);

      // IMPORTANT FIX
      // Update Shopify variant input
      if (variantInput) {
        variantInput.value = variantId;
      }

      updatePrice();
    });
  });

  // ===== DEFAULT ACTIVE VARIANT =====
  const defaultBtn = $('.pd-size.active');

  if (defaultBtn) {

    const variantId = defaultBtn.getAttribute('data-variant-id');

    if (variantId && window.productVariants) {

      selectedVariant = productVariants.find(v => v.id == variantId);

      // IMPORTANT FIX
      if (variantInput) {
        variantInput.value = variantId;
      }

      updatePrice();
    }
  }

  // ===== BACK BUTTON / PAGESHOW FIX =====
  window.addEventListener("pageshow", function (event) {

    if (
      event.persisted ||
      (window.performance &&
        window.performance.navigation.type === 2)
    ) {

      updatePrice();
    }
  });

  // ===== TABS =====
  const tabs = $$('.pd-tab');
  const panels = $$('.pd-tab-panel');

  if (tabs.length) {

    tabs.forEach(tab => {

      tab.addEventListener('click', () => {

        tabs.forEach(t => t.classList.remove('active'));

        panels.forEach(p => p.classList.remove('active'));

        tab.classList.add('active');

        const panel =
          document.getElementById('tab-' + tab.dataset.tab);

        if (panel) {
          panel.classList.add('active');
        }
      });
    });
  }

})();



// Contact page code
// (function () {
//   function handleClick(event) {
//     const cl-ref = event.target.closest(".cl-ref");
//     if (!cl-ref) return;

//     const ct-success = cl-ref.closest(".ct-success");
//     if (ct-success) {
//       ct-success.style.transition = "opacity 0.3s ease";
//       ct-success.style.opacity = "0";

//       setTimeout(() => {
//         ct-success.style.display = "none";
//         window.location.href = "https://aliveinnovations.com/pages/contact-us-26";
//       }, 300);
//     } else {
//       window.location.href = "https://aliveinnovations.com/pages/contact-us-26";
//     }
//   }

//   document.addEventListener("click", handleClick);
// })();


// Acoustic Light Wave js
(() => {
  'use strict';

  /* ------------------ Reveal on Scroll ------------------ */
  const revEls = document.querySelectorAll('.r-up');

  const showAll = () => {
    revEls.forEach(el => el.classList.add('on'));
  };

  if ('IntersectionObserver' in window) {
    const io = new IntersectionObserver((entries, observer) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('on');
          observer.unobserve(entry.target);
        }
      });
    }, {
      threshold: 0.04,
      rootMargin: '0px 0px -10px 0px'
    });

    revEls.forEach(el => io.observe(el));

    setTimeout(showAll, 1000);
  } else {
    showAll();
  }

  /* ------------------ Lightbox ------------------ */
  const galleryImgs = [
    "https://cdn.shopify.com/s/files/1/0224/7891/3616/files/Mask_group-min_1.png?v=1702045893",
    "https://cdn.shopify.com/s/files/1/0224/7891/3616/files/Mask_group_1_-min.png?v=1702045892",
    "https://cdn.shopify.com/s/files/1/0224/7891/3616/files/Mask_group_3_-min.png?v=1702045893"
  ];

  const lb = document.getElementById('alw-lb');
  const lbImg = document.getElementById('alw-lb-img');
  const btnClose = document.getElementById('alw-lb-close');
  const btnPrev = document.getElementById('alw-lb-prev');
  const btnNext = document.getElementById('alw-lb-next');

  let lbIdx = 0;

  const updateImage = () => {
    if (lbImg) lbImg.src = galleryImgs[lbIdx];
  };

  const openLb = (idx = 0) => {
    if (!lb || !lbImg) return;
    lbIdx = idx;
    updateImage();
    lb.classList.add('on');
    document.body.style.overflow = 'hidden';
  };

  const closeLb = () => {
    lb?.classList.remove('on');
    document.body.style.overflow = '';
  };

  const prevImg = () => {
    lbIdx = (lbIdx - 1 + galleryImgs.length) % galleryImgs.length;
    updateImage();
  };

  const nextImg = () => {
    lbIdx = (lbIdx + 1) % galleryImgs.length;
    updateImage();
  };

  // expose globally if needed
  window.openLb = openLb;

  btnClose?.addEventListener('click', closeLb);

  lb?.addEventListener('click', (e) => {
    if (e.target === lb) closeLb();
  });

  btnPrev?.addEventListener('click', prevImg);
  btnNext?.addEventListener('click', nextImg);

  document.addEventListener('keydown', (e) => {
    if (!lb?.classList.contains('on')) return;

    if (e.key === 'Escape') closeLb();
    if (e.key === 'ArrowLeft') prevImg();
    if (e.key === 'ArrowRight') nextImg();
  });

})();


// QC Body Scanner js
(function() {
  /* Reveal */
  var revEls = document.querySelectorAll('.r-up');
  function showAll() { revEls.forEach(function(e) { e.classList.add('on'); }); }
  if (window.IntersectionObserver) {
    var io = new IntersectionObserver(function(entries) {
      entries.forEach(function(e) { if (e.isIntersecting) { e.target.classList.add('on'); io.unobserve(e.target); } });
    }, {threshold:0.04,rootMargin:'0px 0px -10px 0px'});
    revEls.forEach(function(el) { io.observe(el); });
    setTimeout(showAll,1000);
  } else { showAll(); }

  /* Lightbox */
  var lb = document.getElementById('qc-lb');
  var lbImg = document.getElementById('qc-lb-img');
  var lbClose = document.getElementById('qc-lb-close');
  if (lb && lbImg) {
    window.openLb = function(src) {
      lbImg.src = src; lb.classList.add('on');
      document.body.style.overflow = 'hidden';
    };
    function closeLb() { lb.classList.remove('on'); document.body.style.overflow=''; }
    if (lbClose) lbClose.addEventListener('click', closeLb);
    lb.addEventListener('click', function(e) { if (e.target===lb) closeLb(); });
    document.addEventListener('keydown', function(e) { if (e.key==='Escape') closeLb(); });
  }
})();

// VIBEx Passport — Animated Hero Visual
(function(){
  var els = document.querySelectorAll('.vibex-hero-visual');
  els.forEach(function(el){
    if (el.getAttribute('data-vhv-init')) return;
    el.setAttribute('data-vhv-init','1');

    var slides  = el.querySelectorAll('.slide');
    var dots    = el.querySelectorAll('.vhv-dot');
    var card    = el.querySelector('.vhv-card');
    var tilt    = el.querySelector('.vhv-tilt');
    var caption = el.querySelector('.vhv-caption');
    var capB    = caption.querySelector('b');
    var capS    = caption.querySelector('span');
    var chips   = el.querySelectorAll('.vhv-chip');

    var modal   = el.querySelector('.vhv-modal');
    // Move the modal to <body> so its fixed-positioning is always relative to the
    // viewport (theme ancestors can otherwise trap it inside the hero on mobile).
    if (modal && modal.parentNode !== document.body) document.body.appendChild(modal);
    var mainImg = modal.querySelector('.vhv-main-img');
    var thumbsWrap = modal.querySelector('.vhv-thumbs');
    var closeBtn   = modal.querySelector('.vhv-close');

    var srcs = [].map.call(slides, function(s){ return s.getAttribute('src'); });
    var benefits = [
      ['Muscle Tension','Deep vibration relaxes and restores tired, tense muscle.'],
      ['Stress & Fatigue','Frequency entrainment promotes deep relaxation and recovery.'],
      ['Joint Stiffness','vPEMF therapy supports mobility and eases stiff joints.'],
      ['Circulation','Vibroacoustic waves improve flow and reduce inflammation.']
    ];

    var active = 0, hovering = false, timer = null, speed = 3500;

    /* ---- base carousel ---- */
    function setActive(i){
      active = (i + slides.length) % slides.length;
      slides.forEach(function(s,k){ s.classList.toggle('is-active', k===active); });
      dots.forEach(function(d,k){ d.classList.toggle('is-active', k===active); });
    }
    function start(){ stop(); timer = setInterval(function(){ if(!hovering && !el.classList.contains('modal-open')) setActive(active+1); }, speed); }
    function stop(){ if(timer) clearInterval(timer); }
    setActive(0); start();
    dots.forEach(function(d,i){ d.addEventListener('click', function(e){ e.stopPropagation(); setActive(i); start(); }); });

    /* ---- benefit hover caption ---- */
    chips.forEach(function(c){
      var i = +c.getAttribute('data-i');
      c.addEventListener('mouseenter', function(){ hovering=true; el.classList.add('paused'); capB.textContent=benefits[i][0]; capS.textContent=benefits[i][1]; caption.classList.add('open'); });
      c.addEventListener('mouseleave', function(){ hovering=false; el.classList.remove('paused'); caption.classList.remove('open'); });
      c.addEventListener('click', function(e){ e.stopPropagation(); openModal(); });
    });

    /* ---- cursor tilt ---- */
    el.addEventListener('mousemove', function(e){
      if (el.classList.contains('modal-open')) return;
      var r = el.getBoundingClientRect();
      var nx = (e.clientX - r.left) / r.width - 0.5;
      var ny = (e.clientY - r.top) / r.height - 0.5;
      tilt.style.transform = 'perspective(900px) rotateX(' + (-ny*8).toFixed(2) + 'deg) rotateY(' + (nx*8).toFixed(2) + 'deg)';
    });
    el.addEventListener('mouseleave', function(){
      tilt.style.transform = 'perspective(900px) rotateX(0deg) rotateY(0deg)';
      hovering=false; el.classList.remove('paused'); caption.classList.remove('open');
    });

    /* ---- full detail view ---- */
    var mActive = 0;
    function setMain(i){ mActive=i; mainImg.src=srcs[i]; thumbsWrap.querySelectorAll('.vhv-thumb').forEach(function(t,k){ t.classList.toggle('is-active', k===i); }); }
    srcs.forEach(function(src,i){
      var b = document.createElement('button'); b.type='button'; b.className='vhv-thumb';
      var im = document.createElement('img'); im.src=src; im.alt=''; b.appendChild(im);
      b.addEventListener('click', function(){ setMain(i); });
      thumbsWrap.appendChild(b);
    });
    function openModal(){
      setMain(active);
      el.classList.add('modal-open');
      modal.classList.add('is-open');
      document.body.classList.add('vhv-modal-lock');
    }
    function closeModal(){
      el.classList.remove('modal-open');
      modal.classList.remove('is-open');
      document.body.classList.remove('vhv-modal-lock');
    }
    card.addEventListener('click', openModal);
    closeBtn.addEventListener('click', closeModal);
    modal.addEventListener('click', function(e){ if(e.target===modal) closeModal(); });
    document.addEventListener('keydown', function(e){ if(e.key==='Escape') closeModal(); });
  });
})();

// Hydro sh page js
